/* eslint-disable*/
/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable prettier/prettier */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable sonarjs/no-identical-functions */
/* eslint-disable sonarjs/no-collapsible-if */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable no-console */
import React, { useState, useEffect, createContext, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { agreementGlobalStyles } from '../../../JSstyles/agreementGlobalStyles';
import { searchResultStyles } from '../../../JSstyles/searchResultStyles';
import { AgreementContext } from '../../../context/AgreementContext';
import ExceptionController from './exceptionController';
import ContextSkeleton from './contextSkeleton';
import { useLocation } from 'react-router-dom';
import ModalContainer from './modalContainer';
import FooterContent from './footerInventory';
import SearchFilter from './searchCriteria';
import DynamicGridComponent from './grid';
import { useParams } from 'react-router';
import AddedItem from './addedItem';
import { agreementInfoStyles } from '../../../JSstyles/agreementInfoStyles';
import { ReactComponent as WarningIcon } from '../../../assets/images/warningIcon.svg';
import { ReactComponent as Alerticon } from '../../../assets/images/no-records-found.svg';
import { ContainerContext } from '../../../app/App';
import { CustomPropInterface } from '../../../index';
import { getAgreementOptions, getAgreementsByCustomerId, GetCustomerRewardProfile, GetCustomerStgData } from '../../../api/user';
import SecondFactor from '../TwoFactorPopup/TwoFactorPopup';
import { toFiniteNumber } from '../../../utils/deEnforcementUtils';
import { FeatureFlagContext } from '../../../context/FeatureFlagContext';

import {
  getSalesInfo,
  getInventorySearch,
  getPricingClientCall,
  getLegalPriceClientCall,
  GetEmployeeID,
  GetRole,
  // getCompetitors,
} from '../../../api/user';
// import ModalBuilder from "./modalBuilder";

import {
  Grid,
  Card,
  Typography,
  CardContent,
  CircularProgress,
  RACModalCard,
  RACButton,
  Divider,
} from '@rentacenter/racstrap';
import { ADD_ON_PACKAGE, priceOverrideLimit, termOverrideLimit } from '../../../constants/constants';
import { buildLegalPriceRequest, deriveMaximumAllowedTerm } from '../../../utils/legalPriceUtils';
import { useTranslation } from 'react-i18next';
// import { ReactComponent as AlertIcon } from "../../assets/images/no-records-found.svg";
export const Usercontext = createContext({});

export interface columns {
  columnId: string;
  IsSorted: boolean;
  sortOrder: string;
  columnType?: 'link';
  columnTitle: string;
  IsSortable: boolean;
  columnColor?: string;
  subColumns?: columns[];
  handleColumnClick?: () => void;
}

interface Params {
  customerId: string;
  agreementId: string;
}

const SearchResult = (props: any) => {
  const containerData = useContext(ContainerContext) as CustomPropInterface;
  const history = useHistory();
  const search = useLocation().search;
  const classes = agreementGlobalStyles();
  const agrInfoClassName = agreementInfoStyles();
  const agrComponent = searchResultStyles();
  const { customerId } = useParams<Params>();
  const { agreementId } = useParams<Params>();
  const { featureFlagDetails, priceOverrideLimitDetails, termOverrideLimitDetails } = useContext(FeatureFlagContext)


  const { i18n, t } = useTranslation('rental')
  const salesLeadId = new URLSearchParams(search).get('salesLeadId');
  const [CurrentRole, setCurrentRole] = useState('');
  const {
    TestInput,
    addedItem,
    setTestInput,
    searchResult,
    setaddedItem,
    itemArrayData,
    copyArrayData,
    setsearchResult,
    setcopyArrayData,
    setitemArrayData,
    setinitialAgrData,
    initialAgrData,
    setsearchCriteria,
    // setpackageListData,
    agreementCreateStatus,
    searchCriteria,
    setisCompCheck,
    containCompetitor,
    setselectedCompetitor,
    setagreementOptions,
    agreementOptions,
    setproofFileName,
    setisSalesLeadFailed,
    offSetValue,
    setOffSetValue,
    setstoreSelectedPackage,
    storeSelectedPackageValue,
    isAllDone,
    storeSelectedPackagePriceTag,
    setStoreSelectedPackagePriceTag,
    setbrokenPackageData,
    isPackage,
    setIsPackage,
    coworkerCheck,
    customerIdCheck,
    isChoosePriceConfig,
    packageRules,
    setSalesInfoResponse,
    StoreExceptiontype,
    setStoreExceptiontype,
    checkedState,
    setcheckedState,
    initialAgrTerm,
    setInitialAgrTerm,
    setTermOverrideLimitBase,
    legalTotalCost,
    setLegalTotalCost,
    itemPriceTotalCost,
    setItemPriceTotalCost,
    maximumAllowedTotalCost,
    setMaximumAllowedTotalCost,
    maximumAllowedTerm,
    setMaximumAllowedTerm,
    priceController,
    setpriceController,
    setExchangeAgreement,
    setExchangeAgreementId,
    isExchangeAgreement,
    exchangeAgreementId,
    getCustomerResponse,
    setCurrentEmpRole,
    setCustomerReferralCode,
    customerReferralCode,
    setRewardPromotion,
    setIsMotorcycleAdded,
    setIsAnyItemAdded,
    setNoOfInv,
    noOfInv,
    setMotorcycleIdentifiers,
    motorcycleIdentifiers,
    setCoworkerRole,
    verifyLevel,
    setItemSearchDuplicate,
    setAddGetItemPrice,
    customerApprovalDetails,
    setDeEnforcementBaseline,
    somethingWentWrongPopup,
    setSomethingWentWrongPopup,
    } = useContext(AgreementContext);


  const sortDirection = {
    ASC: 'asc',
    DESC: 'desc',
  };

  const resultControllerObj = {
    controlRecord: false,
    controlEmptyRecord: false,
    internalServerController: false,
  };

  const modalStates = {
    breakPopup: false,
    addAllPopUp: false,
    itemPricingFail: false,
    breakPackageCtrl: false,
    RateTermController: false,
    PackageExceptionPopup: false,
    packageExceptionController: false,
    reservedExceptionController: false,
  };
  const ModuleName = 'Choosing Price Tag'; //Need to update this

  // Function to get flexible limits based on current role's config
  const getFlexibleLimits = (roleOverride?: string | null) => {
    // Use roleOverride if provided, otherwise use persisted SlaApprovedRole from ref, otherwise use CurrentRole
    const roleToUse = roleOverride || slaApprovedRoleRef.current || CurrentRole;
    const roleConfig = priceOverrideLimitDetails?.[roleToUse];
    const termRoleConfig = termOverrideLimitDetails?.[roleToUse];



    if (!roleConfig || !termRoleConfig) {
      return {
        rateMin: priceOverrideLimit.min,
        rateMax: priceOverrideLimit.max,
        termMin: termOverrideLimit.min,
        termMax: termOverrideLimit.max
      };
    }

    return {
      rateMin: roleConfig.min ?? priceOverrideLimit.min,
      rateMax: roleConfig.max ?? priceOverrideLimit.max,
      termMin: termRoleConfig.min ?? termOverrideLimit.min,
      termMax: termRoleConfig.max ?? termOverrideLimit.max
    };
  };

  const loaderObj = {
    Gridloader: true,
    masterLoader: false,
    loaderController: false,
  };
  const SLAObj = {
    TwoFactorCancelClick: false,
    TwoFactorCompleted: false,
  };
  const [selectedPackagePriceTag, setselectedPackagePriceTag] = useState(null);
  // const [SLAMinRole, setSLAMinRole] = useState('');
  const [packageInvPopulator, setpackageInvPopulator] = useState([]);
  const [PackageleftValue, setPackageleftValue]: any = useState({});
  const [PackagerightValue, setPackagerightValue]: any = useState({});
  const [packageBlueLabel, setpackageBlueLabel] = useState('');
  const [SLAController, setSLAController] = useState(SLAObj);
  const deleteIdObj = { invDeleteId: '' };
  const [SecondFactorEnabled, setSecondFactorEnabled] = useState(false);
  const [loaderBundle, setLoaderBundle] = useState(loaderObj);
  const [deleteId, setdeleteId] = React.useState(deleteIdObj);
  const [modalController, setmodalController] = useState(modalStates);
  // priceController/setpriceController now sourced from AgreementContext (see destructuring
  // above) so pending rate/term override inputs survive Item Search unmount/remount.
  // Ref to store SLA approved role - persists across renders and avoids stale closure issues
  const slaApprovedRoleRef = React.useRef<string | null>(null);
  // Refs to track previous rate/term for detecting which field triggered the useEffect
  const prevAgrRateRef = React.useRef<any>(priceController.AgrRateInp);
  const prevAgrTermRef = React.useRef<any>(priceController.AgrTermInp);
  const [resultController, setresultController] = useState(resultControllerObj);
  const [tagBlueLabel, settagBlueLabel]: any = useState({});
  const [leftValue, setleftValue]: any = useState({});
  const [openPriceTag, setOpenPriceTag] = useState(false);
  const [openPackagePriceTag, setopenPackagePriceTag] = useState(false);
  const [newSingleInvPricingInvArray, setnewSingleInvPricingInvArray]: any =
    useState([]);
  const [rightValue, setrightValue]: any = useState({});
  const [gridData, setGridData] = useState<any>([]);
  const [itemArray, setItemArray] = useState<any>([]);
  const [salesLeadData, setSalesLeadData]: any = useState();

  const [bucketCopy, setBucketCopy] = useState<any>([]);
  const [collectIndex, setcollectIndex] = useState<any>();
  const [formException, setformException] = useState<any>();
  const [PackageItemId, setPackageItemId] = useState<any>();
  const [packageDeptid, setpackageDeptid] = useState<any>();
  const [showAddedItem, setShowAddedItem] = useState(false);
  const [storeSalesData, setstoreSalesData] = useState<any>();
  const [packageSubdepid, setpackageSubdepid] = useState<any>();
  const [receivedpackage, setreceivedpackage] = useState<any>();
  const [packageCriteria, setpackageCriteria] = useState<any>();
  const [controlViewMode, setControlViewMode] = useState(false);
  const [packageBracketid, setpackageBracketid] = useState<any>();
  const [pricingException, setpricingException] = useState<any>();
  const [footerControlData, setfooterControlData] = useState(true);
  const [PackagePricingResponse, setPackagePricingResponse] = useState<any>();
  const [internalContextData, setInternalContextProvider] = useState<any>();
  // maximumAllowedTerm and legalTotalCost are now sourced from AgreementContext (see
  // destructuring above) instead of local state, because this component unmounts when the
  // user navigates to Agreement Details (Next) and remounts on Previous — local state would
  // reset the TRTO ceiling on every remount. itemPriceTotalCostRef/maximumAllowedTotalCostRef
  // stay as refs for synchronous access within pricingCall, but are seeded from context on
  // mount and mirrored back to context on every update so they also survive remounts.
  const itemPriceTotalCostRef = React.useRef<number | undefined>(itemPriceTotalCost);
  const maximumAllowedTotalCostRef = React.useRef<number | undefined>(maximumAllowedTotalCost);
  // Tracks the latest legal-price request so older responses can be ignored without rerendering.
  const legalPriceCallTrackerRef = React.useRef(0);
  // RP-668: For sequential-only flows (addAllItem, tagPackageInvCaller), legal/price fires silently in the background after pricingCall resolves (no loader). pendingLegalPriceRef holds the in-flight promise so that if the user overrides the term before it settles, addedItem.tsx can await it (showing a loader only in that case) instead of validating against a stale/fallback ceiling.
  const pendingLegalPriceRef = React.useRef<Promise<number | undefined> | null>(null);
  const [getSalesInfoFail, setgetSalesInfoFail] = useState(false);
  const [tireController, settireController] = useState<any>(false);
  const [selectedPackage, setselectedPackage] = useState('');
  const [competitorDDValue, setcompetitorDDValue]: any = useState();
  const [packageList, setpackageListData]: any = useState();
  const [isPackageFlow, setisPackageFlow] = useState(false);
  const [collectCompetitor, setcollectCompetitor] = useState();
  const [employeeId, setEmployeeId] = useState("");
  const [PricexeptionMessage, setPricexeptionMessage] = useState('');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [coCustomerId, setcocustomerId] = useState('');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [coCustomerName, setcoCustomerName] = useState('');
  const storeNumber = window.sessionStorage.getItem('storeNumber');
  const [hasMore, sethasMore] = useState(true);
  const [scrollLoader, setscrollLoader] = useState(false);
  const [payloadSetNumber, setpayloadSetNumber] = useState<any>(1);
  const [verificationWarningPopup, setverificationWarningPopup] = useState(false)
  const [verifcationRequiredContinue, setVerifcationRequiredContinue] = useState(false)
  const dynamicViewClass = controlViewMode
    ? agrComponent.disableme
    : 'enableme';
  const altersearch = showAddedItem
    ? agrComponent.collapsedWigid
    : agrComponent.expandWigid;

  const showItemSearch = isAllDone
    ? agrComponent.showItemSearch
    : agrComponent.hideItemSearch;
  const queryParams = new URLSearchParams(window.location.search);
  const [itemAllowed, setItemAlowed] = useState<any>('');
  const [PackageNotAvailableOpen, setPackageNotAvailableOpen] = useState(false);

  const storeDefaultAgreementTerm = (responseData: any) => {
    const effectiveTerm = isExchangeAgreement
      ? responseData?.agreementPricing?.exchangeAgreementTerm ??
        responseData?.agreementPricing?.agreementTerm
      : responseData?.agreementPricing?.agreementTerm;

    if (
      effectiveTerm !== null &&
      effectiveTerm !== undefined &&
      effectiveTerm !== '' &&
      !isNaN(Number(effectiveTerm))
    ) {
      const numericTerm = Number(effectiveTerm);
      // A new item/package starts SLA validation from the term currently shown in the UI.
      setInitialAgrTerm(numericTerm);
      setTermOverrideLimitBase(numericTerm);
    }
  };


  console.log('somethingWentWrongOpen', somethingWentWrongPopup)

  useEffect(() => {
    console.log(
      'vcxbvbjnbvb 545451 newSingleInvPricingInvArray',
      newSingleInvPricingInvArray
    );
    console.log(
      'sdvfddcvd 541495151 loaderBundle.masterLoader',
      loaderBundle.masterLoader
    );
  }, [newSingleInvPricingInvArray, itemArray, loaderBundle.masterLoader]);


  useEffect(() => {
    console.log('ksdhfkdhkdshkjdhkdsjhsdkjhds', getCustomerResponse)
    if (getCustomerResponse && (getCustomerResponse?.GetApproval?.value?.customerApprovalDetails?.verificationStatus != 'COMPLETED' && getCustomerResponse?.GetApproval?.value?.customerApprovalDetails?.verificationStatus != 'NOTREQUIRED') && featureFlagDetails?.CustomerVerificationOptimization == 1 && featureFlagDetails?.MXDecisionEngine != 1) {
      setverificationWarningPopup(true)
    }
    if (getCustomerResponse && featureFlagDetails.EnableRewardPromotion == '1') {


      const referralReward = async () => {
        if (customerReferralCode == undefined) {
          const rewardPromotion: any = await fetchCustomerAdvocteReferralCode(getCustomerResponse);
          setCustomerReferralCode(!rewardPromotion?.isCustomerHasActiveAgreement ? rewardPromotion?.referralCode : undefined);
          setRewardPromotion(rewardPromotion);
        }
      }
      referralReward()
      // const customerVerifyLevelRestriction = getCustomerResponse?.GetApproval?.value?.customerApprovalDetails?.verifyLevel;
      // console.log('customerVerifyLevelRestriction 123456', customerVerifyLevelRestriction)
      const itemTypesEnAllowedFlag = JSON.parse(featureFlagDetails?.ItemRestrictionCustomerLevels);
      const itemTypesEnAllowed = itemTypesEnAllowedFlag?.itemTypeEn;
      console.log(itemTypesEnAllowed, 'itemTypesEnAllowed');
      setItemAlowed(itemTypesEnAllowed);
    }
    if (getCustomerResponse && (getCustomerResponse?.GetCustomer?.value?.stgCustomerProfileId)) {
      const getStageDet = async () => {
        const GetCustomerStgDataRes = await GetCustomerStgData(getCustomerResponse?.GetCustomer?.value?.stgCustomerProfileId);
        console.log("GetCustomerStgDataRes", GetCustomerStgDataRes);
        if (GetCustomerStgDataRes?.status == 200) {
          if (GetCustomerStgDataRes?.data?.productCode && GetCustomerStgDataRes?.data?.customerSource == 'MX-EC') {
            const req: any = {
              itemNo: '',
              serialNo: '',
              bracket: '',
              brand: '',
              model: GetCustomerStgDataRes?.data?.productCode,
              statusId: 1,
              conditionId: null,
              departments: '',
              subDepartments: '',
              packageTypeval: '',
              locationNumber: '',
            };
            setsearchCriteria({
              ...searchCriteria,
              model: req.model
            });
            searchClick(req, 'searchButtonClick');
          }
        }
      }
      getStageDet()
    }
  }, [getCustomerResponse])

  const fetchCustomerAdvocteReferralCode = async (getCustomerResponse) => {
    let referralCode
    let response
    let rewardPromotionRes: any
    let isCustomerHasActiveAgreement = false
    let phoneNumber = getCustomerResponse?.GetCustomer?.value.phones?.filter((obj) => obj.primary == 'Y' && obj.active == 'Y') ?? []
    const payload = {
      globalCustomerId: String(getCustomerResponse?.GetCustomer?.value?.globalCustomerId),
      lob: 'RTO',
      includeBalance: 'Y',
      includeReferral: 'Y',
      includeProgram: 'Y',
      includeReferredBy: 'Y',
      firstName: getCustomerResponse?.GetCustomer?.value?.firstName ?? undefined,
      lastName: getCustomerResponse?.GetCustomer?.value?.lastName ?? undefined,
      email: getCustomerResponse?.GetCustomer?.value?.emailAddress ?? undefined,
      phoneNumber: phoneNumber?.length > 0 ? phoneNumber[0]?.phoneNumber : undefined,
      storeNumbers: [window.sessionStorage.getItem("storeNumber")]
    }
    await Promise.all([
      GetCustomerRewardProfile({ rewardProfile: payload }),
      getAgreementsByCustomerId(customerId),
    ]).then((resp) => {
      [rewardPromotionRes, response] = resp;
    })

    if (rewardPromotionRes?.status == 200) {
      referralCode = rewardPromotionRes?.data?.referralProgram?.referredByList.length > 0 ? rewardPromotionRes?.data?.referralProgram.referredByList[0].referralCode : undefined
    }
    if (response?.status == 200 && response?.data?.agreement?.length > 0) {

      isCustomerHasActiveAgreement = response.data.agreement.some(
        (e: any) => e?.agreementStatus == 'Active')

    }
    return { referralCode, isCustomerHasActiveAgreement }
  }
  useEffect(() => {
    let employeeIdGA: any
    let loggedRole: any
    const GettingRole = async () => {
      const GetcurrentUser = await GetEmployeeID();
      console.log('GetcurrentUser', GetcurrentUser);
      if (GetcurrentUser.status === 200) {
        const GetcurrentUserResponse = GetcurrentUser.data;
        const EmployeeId = GetcurrentUserResponse.employeeId;
        const GetMenuPayload = {
          coworkerId: EmployeeId,
        };
        const GetMenuDetails: any = await GetRole(GetMenuPayload);
        console.log('GetMenuDetails', GetMenuDetails);
        if (GetMenuDetails.status === 200) {
          const GetMenuDetailsResponse = GetMenuDetails?.data;
          const currentRole = GetMenuDetailsResponse?.coworkerProfile?.role;
          setEmployeeId(GetMenuDetailsResponse?.coworkerProfile?.employeeId);
          loggedRole = currentRole
          console.log('currentRole', currentRole);
          setCurrentRole(currentRole);
          setCoworkerRole(currentRole)
          setCurrentEmpRole(currentRole);
          employeeIdGA = GetMenuDetailsResponse?.coworkerProfile?.employeeId
          window.localStorage.setItem('currentRole', currentRole);
        }
      }
    };
    if (containerData !== undefined) {
      console.log('containerData', containerData);
      console.log('containerDataRole', containerData.GetRole());
      setCurrentRole(containerData.GetRole());
      setCurrentEmpRole(containerData.GetRole());
      setEmployeeId(containerData?.GetEmployeeId());
      loggedRole = containerData.GetRole()
      employeeIdGA = containerData?.GetEmployeeId()
      window.localStorage.setItem('currentRole', containerData.GetRole());
    } else {
      GettingRole();
    }
    window?.dataLayer?.push({
      'event': 'Loaded the Rental-Agreement Item search page',
      'customerId': customerId,
      'storeNo': storeNumber,
      'agreementNo': agreementId,
      'employeeId': employeeIdGA,
      'role': loggedRole,
      'currentScreen': 'Rental-Agreement Item Search',
      'previousScreen': 'Customer Search',
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // console.log("before getSearchCriteriaContext", getSearchCriteriaContext);
    if (featureFlagDetails?.MXMotorcycleIdentifier) {
      const parseDept = JSON.parse(featureFlagDetails.MXMotorcycleIdentifier);
      setMotorcycleIdentifiers(parseDept.mxSubDept)
      console.log(parseDept.mxSubDept, "parseDept");
    }
    console.log('before getsearchResultContext', searchResult);
    console.log('before getaddedItemContext', addedItem);
    console.log('before getItemArray', itemArrayData);
    console.log('before getCopyArray', copyArrayData);
    console.log('Status of the agreement is', agreementCreateStatus);

    if (
      // getSearchCriteriaContext[0] !== undefined &&
      addedItem !== undefined &&
      searchResult !== undefined &&
      itemArrayData !== undefined &&
      copyArrayData !== undefined &&
      agreementCreateStatus !== undefined
    ) {
      console.log('entered');
      if (agreementCreateStatus.agreementCreatedStatus === true) {
        console.log('entered view mode');
        console.log('entered view mode with getaddedItemContext[0]', addedItem);
        setShowAddedItem(true);
        setControlViewMode(true);
        setfooterControlData(false);
        setInternalContextProvider(addedItem);
      } else {
        console.log('entered edit mode');
        setselectedPackagePriceTag(storeSelectedPackagePriceTag);
        setpayloadSetNumber(offSetValue);
        setShowAddedItem(true);
        setGridData(searchResult);
        setItemArray(itemArrayData);
        setBucketCopy(copyArrayData);
        setInternalContextProvider(addedItem);
        // setloaderController(false);
        // setGridloader(false);
        setLoaderBundle({
          ...loaderBundle,
          Gridloader: false,
          loaderController: false,
        });
        setselectedPackage(storeSelectedPackageValue);
        setfooterControlData(false);
      }
    }

    if (
      searchCriteria !== undefined &&
      searchCriteria.packageTypeval !== undefined &&
      searchCriteria.packageTypeval !== ''
    ) {
      setreceivedpackage(searchCriteria.packageTypeval);
      setpackageCriteria(packageRules);
    }
    console.log('containCompetitor to get check', containCompetitor);

    async function GetDropdownApiCall() {
      const dropdownval: any = await getAgreementOptions(
        customerId,
        storeNumber
      );
      console.log('New res', dropdownval);
      if (dropdownval.status === 200) {
        setagreementOptions(dropdownval.data);
      }
    }
    if (agreementOptions == undefined) {
      GetDropdownApiCall();
    }
    // End of Competitor DD Call
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const window: any = {}
    const dataLayer: any = []
    window.dataLayer = dataLayer || [];
    dataLayer.push({
      'event': 'Loaded the Rental-Agreement Item search page',
      'customerId': customerId,
      'storeNo': storeNumber,
      'agreementNo': 'No agreement Number in the Rental Agreement Item search ',
      'employeeId': employeeId,
      'currentScreen': 'Rental-Agreement Item Search',
      'previousScreen': 'Customer Search',
    });
    const isExchangeQP: any = queryParams.get('isExchange');
    const exchangeAgreementQP: any = queryParams.get('agreementId');
    setExchangeAgreement(isExchangeQP == 1 ? true : false);
    setExchangeAgreementId(parseInt(exchangeAgreementQP));
  }, [])

  const pull_data = (data) => {
    setcocustomerId(data.coCustomerId);
    setcoCustomerName(data.coCustomerName);
    props.func({
      coCustomerId: data.coCustomerId,
      coCustomerName: data.coCustomerName,
    });
    // eslint-disable-next-line no-console
    console.log('Search Result Props', data); // LOGS DATA FROM CHILD (My name is Dean Winchester... &)
  };

  const suppiler = () => {
    console.log('response in suppiler');
    console.log('fdgshjhsh');
    props.somedeeptrigger();
  };

  useEffect(() => {
    if (salesLeadId !== null) {
      const salesValue = async () => {
        const salesData = await getSalesInfo(salesLeadId);
        if (salesData.status == 200) {
          setstoreSalesData(salesData.data);
          setSalesInfoResponse(salesData.data);
          if (salesData.data.inventories[0].reservedStoreNumber === null) {
            if (salesData.data.inventories.length > 1) {
              const req: any = {
                itemNo: '',
                serialNo: '',
                bracket: '',
                brand: '',
                model: '',
                statusId: 1,
                conditionId: null,
                departments: '',
                subDepartments: '',
                packageTypeval: salesData.data.bundleId,
                locationNumber: '',
              };
              setselectedPackage(salesData.data.bundleId);
              setstoreSelectedPackage(salesData.data.bundleId);
              searchClick(req, 'searchButtonClick');
            } else {
              const req: any = {
                itemNo: '',
                serialNo: '',
                bracket: '',
                brand: '',
                model: salesData.data.inventories[0].modelNumber,
                statusId: 1,
                conditionId: null,
                departments: '',
                subDepartments: '',
                packageTypeval: '',
                locationNumber: '',
              };
              searchClick(req, 'searchButtonClick');
            }
          } else {
            if (salesData.data.inventories.length > 1) {
              let isAllReserved = true;
              const arrayStorage: any = [];
              salesData.data.inventories.map((obj: any) => {
                if (obj.reserved === true) {
                  arrayStorage.push(obj.inventoryNumber);
                }
              });

              for (let i = 0; i < salesData.data.inventories.length; i++) {
                if (salesData.data.inventories[i].reserved === false) {
                  isAllReserved = false;
                  break;
                }
              }
              console.log(
                'final data of isAllReserved statuscb',
                isAllReserved
              );
              console.log('gbdv6584dfa65b45fd', arrayStorage);

              if (isAllReserved) {
                const currentStore = sessionStorage.getItem('storeNumber');
                const req: any = {
                  storeNumbers: [currentStore],
                  itemNumber: arrayStorage,
                  serialNumber: '',
                  bracket: '',
                  brand: '',
                  modelNumber: '',
                  statusId: 1,
                  subStatusId: [2, 6],
                  conditionId: null,
                  department: '',
                  subDepartment: '',
                  packageName: '',
                  isActivePriceTag: true,
                };
                try {

                  const response: any = await getInventorySearch(req);
                  const arrayCollecter: any = [];
                  if (response.status === 400) {
                    const errorMessage = response.data.errors[0].error;
                    const packageName = req.packageName;
                    console.log('Errormessage: ', errorMessage, 'packagename:', packageName);

                    if (errorMessage === `No package types in this packageName :${packageName}`) {
                      setPackageNotAvailableOpen(true);
                    } else {
                      setSomethingWentWrongPopup(true);
                    }
                  } else if (
                    response.status == 200 &&
                    response.data.response.length === 1
                  ) {
                    setItemSearchDuplicate(prevState => {
                      const newItems = {};
                      response.data.response.forEach(item => {
                        newItems[item.inventoryId] = item;
                      });
                      return { ...prevState, ...newItems };
                    });
                    salesLeadSingleAdder(
                      {
                        inventoryId: Number(
                          response.data.response[0].inventoryId
                        ),
                        inventoryPriceId: Number(
                          response.data.response[0].inventoryPriceId
                        ),
                      },
                      response.data.response[0]
                    );
                  } else if (
                    response.status == 200 &&
                    response.data.response.length > 1
                  ) {
                    setItemSearchDuplicate(prevState => {
                      const newItems = {};
                      response.data.response.forEach(item => {
                        newItems[item.inventoryId] = item;
                      });
                      return { ...prevState, ...newItems };
                    });
                    response.data.response.map((filteredDataObj: any) => {
                      arrayCollecter.push({
                        inventoryId: Number(filteredDataObj.inventoryId),
                        inventoryPriceId: Number(
                          filteredDataObj.inventoryPriceId
                        ),
                      });
                    });

                    salesLeadPackageAdder(
                      arrayCollecter,
                      salesData.data.bundleId,
                      response.data.response
                    ); // Need to change here
                  } else if (
                    response.status == 200 &&
                    response.data.response.length == 0
                  ) {
                    const req: any = {
                      itemNo: '',
                      serialNo: '',
                      bracket: '',
                      brand: '',
                      model: '',
                      statusId: 1,
                      conditionId: null,
                      departments: '',
                      subDepartments: '',
                      packageTypeval: salesData.data.bundleId,
                      locationNumber: '',
                    };
                    searchClick(req, 'searchButtonClick');
                  }
                  console.log('bgdvdsv654f1vdf', arrayCollecter);
                } catch {
                  setresultController({
                    ...resultControllerObj,
                    internalServerController: true,
                  });
                  setLoaderBundle({ ...loaderBundle, loaderController: false });
                  setSomethingWentWrongPopup(true)
                }
              } else if (!isAllReserved) {
                console.log('package observdvs564', salesData.data.bundleId);

                const req: any = {
                  itemNo: '',
                  serialNo: '',
                  bracket: '',
                  brand: '',
                  model: '',
                  statusId: 1,
                  conditionId: null,
                  departments: '',
                  subDepartments: '',
                  packageTypeval: salesData.data.bundleId,
                  locationNumber: '',
                };
                setselectedPackage(salesData.data.bundleId);
                setstoreSelectedPackage(salesData.data.bundleId);
                searchClick(req, 'searchButtonClick');
              }
            } else {
              const currentStore = sessionStorage.getItem('storeNumber');
              const req: any = {
                storeNumbers: [currentStore],
                itemNumber: [salesData.data.inventories[0].inventoryNumber],
                serialNumber: '',
                bracket: '',
                brand: '',
                modelNumber: '',
                statusId: 1,
                subStatusId: [2, 6],
                conditionId: null,
                department: '',
                subDepartment: '',
                packageName: '',
                isActivePriceTag: true,
              };
              try {
                const response: any = await getInventorySearch(req);
                // setItemSearchDuplicate(prevState => [...prevState, ...response.data.response]);
                console.log(response, "hey response");
                console.log('fgvbdsv5fd4', response);
                if (response.status === 400) {
                  const errorMessage = response.data.errors[0].error;
                  const packageName = req.packageName;
                  console.log('Errormessage: ', errorMessage, 'packagename:', packageName)

                  if (errorMessage === `No package types in this packageName :${packageName}`) {

                    setPackageNotAvailableOpen(true);
                  } else {
                    console.log('inside package else ')
                    setSomethingWentWrongPopup(true);
                  }
                }
                else if (
                  response.status == 200 &&
                  response.data.response.length > 0
                ) {
                  setItemSearchDuplicate(prevState => {
                    const newItems = {};
                    response.data.response.forEach(item => {
                      newItems[item.inventoryId] = item;
                    });
                    return { ...prevState, ...newItems };
                  });
                  console.log(
                    'gbdfvsd vds',
                    response.data.response[0].inventoryId
                  );
                  salesLeadSingleAdder(
                    {
                      inventoryId: Number(
                        response.data.response[0].inventoryId
                      ),
                      inventoryPriceId: Number(
                        response.data.response[0].inventoryPriceId
                      ),
                    },
                    response.data.response[0]
                  );
                } else {
                  setresultController({
                    ...resultControllerObj,
                    controlRecord: true,
                  });
                  setLoaderBundle({ ...loaderBundle, loaderController: false });
                  setSalesLeadData({
                    itemNo: salesData.data?.inventories[0].inventoryNumber
                      ? salesData.data?.inventories[0].inventoryNumber
                      : '',
                    packageTypeval: '',
                  });
                }
              } catch {
                console.log('else of package')
                setSomethingWentWrongPopup(true)
                setresultController({
                  ...resultControllerObj,
                  internalServerController: true,
                });
                setLoaderBundle({ ...loaderBundle, loaderController: false });

              }
            }
          }
        } else {
          setgetSalesInfoFail(true);
          setisSalesLeadFailed(true);
        }
      };
      salesValue();
    }
    console.log('Received Query Param Data', salesLeadId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [salesLeadId, verifyLevel, itemAllowed]);

  useEffect(() => {
    console.log(props);
    if (itemArray !== undefined && itemArray.length > 0) {
      console.log('selectedPackage in rate change', selectedPackage);

      // Detect which field the user just changed
      const rateChanged = priceController.AgrRateInp !== prevAgrRateRef.current;
      const termChanged = priceController.AgrTermInp !== prevAgrTermRef.current;
      prevAgrRateRef.current = priceController.AgrRateInp;
      prevAgrTermRef.current = priceController.AgrTermInp;

      // Determine what to send based on which field changed
      let agreementRateToSend: number | null = null;
      let agreementTermToSend: number | null = null;

      if (rateChanged && !termChanged) {
        // Rate override: send rate + overriddenTotalCost, term = null
        agreementRateToSend = priceController.AgrRateInp != '' && priceController.AgrRateInp != null
          ? parseFloat(priceController.AgrRateInp)
          : null;
        agreementTermToSend = null;
      } else if (termChanged && !rateChanged) {
        // Term override: send term, send rate if previously set, no overriddenTotalCost
        agreementRateToSend = priceController.AgrRateInp != '' && priceController.AgrRateInp != null
          ? parseFloat(priceController.AgrRateInp)
          : null;
        agreementTermToSend = priceController.AgrTermInp != '' && priceController.AgrTermInp != null
          ? parseInt(priceController.AgrTermInp)
          : null;
      } else {
        // Both changed or initial — send as-is
        agreementRateToSend = priceController.AgrRateInp != '' && priceController.AgrRateInp != null
          ? parseFloat(priceController.AgrRateInp)
          : null;
        agreementTermToSend = priceController.AgrTermInp != '' && priceController.AgrTermInp != null
          ? parseInt(priceController.AgrTermInp)
          : null;
      }

      // setmasterLoader(true);
      setLoaderBundle({ ...loaderBundle, masterLoader: true });
      const AgrRateTerm = async () => {
        console.log('function call');
        let packageParameter: any = '';
        let packagePriceType: any = null;
        packageParameter = selectedPackage;
        if (isPackage) {
          packagePriceType = selectedPackagePriceTag;
        }
        // If the MaxTRTO override feature is disabled, always send the current
        // controller values (so a term-first then rate flow still sends both).
        const finalAgreementRateToSend = featureFlagDetails?.EnableMaxTRTOBasedAgrOverride != '1'
          ? (priceController.AgrRateInp != '' && priceController.AgrRateInp != null ? parseFloat(priceController.AgrRateInp) : null)
          : agreementRateToSend;
        const finalAgreementTermToSend = featureFlagDetails?.EnableMaxTRTOBasedAgrOverride != '1'
          ? (priceController.AgrTermInp != '' && priceController.AgrTermInp != null ? parseInt(priceController.AgrTermInp) : null)
          : agreementTermToSend;

        const ClientCallResponse = await pricingCall(//If agreement Rate and term updated means it will works.
          itemArray,
          null,
          isPackage,
          finalAgreementRateToSend,
          finalAgreementTermToSend,
          priceController.CompetitorCheck,
          packageParameter,
          packagePriceType,
          null // SLA role is now managed via slaApprovedRoleRef
        );
        // setmasterLoader(false);
        setLoaderBundle({ ...loaderBundle, masterLoader: false });

        if (
          ClientCallResponse !== undefined &&
          ClientCallResponse.status == 200
        ) {
          if (priceController.CompetitorCheck == true) {
            setStoreExceptiontype({
              ...StoreExceptiontype,
              agrRateorTermEdited: false,
              competitorChecked: true
            })
          }
          else if (
            ((priceController.AgrRateInp != '' && priceController.AgrRateInp != null) || (priceController.AgrTermInp != '' && priceController.AgrTermInp != null))
          ) {
            setStoreExceptiontype({
              ...StoreExceptiontype,
              agrRateorTermEdited: true,
              competitorChecked: false
            })
          }
          else {
            setStoreExceptiontype({
              ...StoreExceptiontype,
              agrRateorTermEdited: false,
              competitorChecked: false
            })
          }

          if (
            rateChanged &&
            !termChanged &&
            finalAgreementRateToSend != null &&
            finalAgreementTermToSend == null
          ) {
            const effectiveTerm = isExchangeAgreement
              ? ClientCallResponse.data?.agreementPricing?.exchangeAgreementTerm ??
                ClientCallResponse.data?.agreementPricing?.agreementTerm
              : ClientCallResponse.data?.agreementPricing?.agreementTerm;
            if (
              effectiveTerm !== null &&
              effectiveTerm !== undefined &&
              effectiveTerm !== '' &&
              !isNaN(Number(effectiveTerm))
            ) {
              // After any rate-only pricing response, validate later term edits from the latest term shown in the UI.
              setTermOverrideLimitBase(Number(effectiveTerm));
            }
          }





          // Recalculate the term ceiling from the greater legal/item-price TRTO and latest rate.
          const maximumAllowedTotalCost = deriveMaximumAllowedTotalCost(
            legalTotalCost,
            itemPriceTotalCostRef.current
          );
          if (
            maximumAllowedTotalCost != null &&
            Number(ClientCallResponse.data?.agreementPricing?.agreementRate)
          ) {
            const computedMaximumAllowedTerm = deriveMaximumAllowedTerm(
              String(maximumAllowedTotalCost),
              ClientCallResponse.data.agreementPricing.agreementRate,
              Number(ClientCallResponse.data?.agreementPricing?.agreementTerm)
            );
            setMaximumAllowedTerm(computedMaximumAllowedTerm);
          }

          setInternalContextProvider(ClientCallResponse.data);//fires when user overrides rate or term on already-added items
          // The existing flow kept override and package state in the same component lifetime; after priceController
          // moved to context, overrides survive remounts while local package criteria reset. Restore the latest matching
          // package criteria and name so Next does not silently remain on Item Search without validation rules.
          const overridePackageTypeList =
            ClientCallResponse.data?.packageInformation?.packageTypeList;
          if (Array.isArray(overridePackageTypeList) && overridePackageTypeList.length > 0) {
            const overridePackageName =
              ClientCallResponse.data?.itemPricing?.[0]?.packageName;
            const overridePackage =
              overridePackageTypeList.find(
                (item: any) => item.packageName == overridePackageName
              ) ?? overridePackageTypeList[0];
            setpackageCriteria(overridePackage.packageCriteria);
            setreceivedpackage(overridePackage.packageName);
          }
          // provideContext(ClientCallResponse.data, itemArray);
          ContextSkeleton(
            ClientCallResponse.data,
            itemArray,
            setTestInput,
            customerId,
            priceController,
            competitorDDValue,
            TestInput.TireAgreementFlow
          );
          // Store latest agreementTotal from response as overriddenTotalCost
          if (featureFlagDetails?.EnableMaxTRTOBasedAgrOverride == '1') {
            const latestTotal = ClientCallResponse.data.agreementPricing?.agreementTotal;
            if (latestTotal != null) {
              setpriceController(prev => ({
                ...prev,
                overriddenTotalCost: parseFloat(latestTotal)
              }));
            }
          }
          // setaddedItemContext(ClientCallResponse.data);
          setaddedItem(ClientCallResponse.data);


        } else if (
          ClientCallResponse !== undefined &&
          ClientCallResponse.status == 400
        ) {
          setpricingException(ClientCallResponse.data.errors[0].error);
          setmodalController({ ...modalController, RateTermController: true });

          // setinvalidTerm(true);
        }
      };
      AgrRateTerm();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    priceController.AgrRateInp,
    priceController.AgrTermInp,
    //priceController.CompetitorCheck,
  ]);
  //AgrRateInp, AgrTermInp, CompetitorCheck
  // eslint-disable-next-line sonarjs/cognitive-complexity
  useEffect(() => {
    console.log('vaue of id in useeffect', deleteId.invDeleteId);
    if (deleteId.invDeleteId !== '') {
      if (isPackage) {
        // setbreakPackageCtrl(true);
        setmodalController({ ...modalController, breakPackageCtrl: true });

        console.log('Came Inside Is Package');
      } else if (!isPackage) {
        console.log('Came Inside Not Package');
        deleteItem();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteId]); // this method is used to manipulate the data item based in the delete in the addedadd item menu

  const salesLeadSingleAdder = async (itemid: any, itemObject: any) => {
    setLoaderBundle({ ...loaderBundle, masterLoader: true });
    console.log('6r8sgd1v5f1', itemid);

    const { response } = await pricingCallWithLegalPrice( //Sales Lead single inv Price Call.
      [itemid],
      null,
      false,
      null,
      null,
      false,
      '',
      null
    );
    setLoaderBundle({ ...loaderBundle, masterLoader: false });
    setaddedItem(response.data);
    let newItemArray: any = [];
    if (response.status == 200) {
      const constructedItemArray = [];

      let tireController: any = false;
      response.data.itemPricing.map((obj: any) => {
        if (
          obj.rmsItemNumber == '200012120' ||
          obj.rmsItemNumber == '200012121' ||
          obj.rmsItemNumber == '200013177' ||
          obj.rmsItemNumber == '200012118' ||
          obj.rmsItemNumber == '200013350' ||
          obj.rmsItemNumber == '200012119'
        ) {
          tireController = true;
          settireController(true);
        }
      });
      newItemArray = [itemid]; // need to store inv id now its number
      setinitialAgrData(response.data.agreementPricing.agreementRate);
      storeDefaultAgreementTerm(response.data); // Sales-lead single-item flow
      ContextSkeleton(
        response.data,
        newItemArray,
        setTestInput,
        customerId,
        priceController,
        competitorDDValue,
        tireController
      );
      // Store latest agreementTotal from response as overriddenTotalCost
      if (featureFlagDetails?.EnableMaxTRTOBasedAgrOverride == '1') {
        const latestTotal = response.data.agreementPricing?.agreementTotal;
        if (latestTotal != null) {
          setpriceController(prev => ({
            ...prev,
            overriddenTotalCost: parseFloat(latestTotal)
          }));
        }
      }
      setIsPackage(false);
      console.log('newItemArray in add item', newItemArray);

      setItemArray(newItemArray);
      console.log(itemArrayData, 'RESPP')
      console.log(itemArray, "kkk")

      setitemArrayData(newItemArray);

      setfooterControlData(false);
      setInternalContextProvider(response.data);
      setBucketCopy([itemObject]);
      setcopyArrayData([itemObject]);
      setShowAddedItem(true);
    } else if (response.status == 400) {
      setpricingException(response.data.errors[0].error);
      setmodalController({ ...modalController, RateTermController: true });
    }
  };

  const salesLeadPackageAdder = async (
    itemid: any,
    packageValue: any,
    itemObj: any
  ) => {
    setLoaderBundle({ ...loaderBundle, masterLoader: true });
    console.log('bd65v4fd65vfb6fd', itemid);

    const { response } = await pricingCallWithLegalPrice(// Sales lead Package Item Use Case
      itemid,
      null,
      false,
      null,
      null,
      false,
      packageValue,
      null
    );
    setLoaderBundle({ ...loaderBundle, masterLoader: false });
    setaddedItem(response.data);
    // let newItemArray: any = [];
    if (response.status == 200) {
      // const constructedItemArray = [];
      setselectedPackage(packageValue);
      setstoreSelectedPackage(packageValue);
      let tireController: any = false;
      response.data.itemPricing.map((obj: any) => {
        if (
          obj.rmsItemNumber == '200012120' ||
          obj.rmsItemNumber == '200012121' ||
          obj.rmsItemNumber == '200013177' ||
          obj.rmsItemNumber == '200012118' ||
          obj.rmsItemNumber == '200013350' ||
          obj.rmsItemNumber == '200012119'
        ) {
          // settireController(true);
          tireController = true;
          settireController(true);
        }
      });
      const newItemArray: any = [];
      if (response.data !== undefined) {
        response.data.itemPricing.map((value: any) => {
          console.log('individual inv id of package', value.inventoryId);
          newItemArray.push({
            inventoryId: Number(value.inventoryId),
            inventoryPriceId: Number(value.inventoryPriceId),
          });
          //newItemArray = [...newItemArray, parseInt(value.inventoryId)];
        });

        if (
          response.data.packageInformation.packageTypeList !== null &&
          Object.keys(response.data.packageInformation.packageTypeList)
            .length !== 0 &&
          response.data.packageInformation.packageTypeList !== ''
        ) {
          if (packageValue == '') {
            setpackageCriteria(
              response.data.packageInformation.packageTypeList[0]
                .packageCriteria
            );
          } else {
            const filteredCriteria =
              response.data.packageInformation.packageTypeList.filter(
                (item, index) => {
                  if (packageValue == item.packageName) {
                    return item;
                  }
                }
              );
            setpackageCriteria(filteredCriteria[0].packageCriteria);
          }
          setreceivedpackage(response.data.itemPricing[0].packageName);
          setsearchCriteria({
            ...searchCriteria,
            packageTypeval: response.data.itemPricing[0].packageName,
          });
        } else {
          setpackageCriteria(null);
        }
      }
      setinitialAgrData(response.data.agreementPricing.agreementRate);
      storeDefaultAgreementTerm(response.data); // Sales-lead package flow

      ContextSkeleton(
        response.data,
        newItemArray,
        setTestInput,
        customerId,
        priceController,
        competitorDDValue,
        tireController
      );
      // Store latest agreementTotal from response as overriddenTotalCost
      if (featureFlagDetails?.EnableMaxTRTOBasedAgrOverride == '1') {
        const latestTotal = response.data.agreementPricing?.agreementTotal;
        if (latestTotal != null) {
          setpriceController(prev => ({
            ...prev,
            overriddenTotalCost: parseFloat(latestTotal)
          }));
        }
      }
      setfooterControlData(false);
      setIsPackage(true);
      setItemArray(newItemArray);
      setitemArrayData(newItemArray);
      setpackageListData(response.data.packageInformation.packageTypeList);
      setInternalContextProvider(response.data);
      setBucketCopy(itemObj);
      setcopyArrayData(itemObj);
      setShowAddedItem(true);
      setaddedItem(response.data);
    } else if (response.status == 400) {
      setpricingException(response.data.errors[0].error);
      setmodalController({ ...modalController, RateTermController: true });
    }
  };

  const minMaxException = (index: any) => {
    console.log('index log of fault package', index);

    if (packageCriteria !== undefined) {
      const wordingArray: any = [
        t('Items in the Agreement do not meet the Package Criteria. Please check the Item in the Agreement to Continue.'),
      ];
      index.forEach((obj: any) => {
        const wordFormation = `${obj.rmsDepartment} ${t('Minimum')}: ${obj.originalMinQuantity} ${t('Maximum')}: ${obj.originalMaxQuantity}`;
        wordingArray.push(wordFormation);
      });
      console.log('wordingArray finally', wordingArray);

      if (wordingArray !== undefined && wordingArray.length > 0) {
        let str: any = '';
        wordingArray.map((el: any) => {
          str = str + el;
        });
        console.log('str formed value', str);

        setformException(str);
      }
      setmodalController({ ...modalController, PackageExceptionPopup: true });
    }
  };

  const pricingCall = async (
    inventoriesValue: any,
    validateInventoryIdValue: any,
    packageRequiredValue: any,
    agreementRateValue: any,
    agreementTermValue: any,
    isCompetitorMatchValue: any,
    packageNameValue: any,
    packagePriceType: any,
    slaApprovedRoleParam?: string | null
  ) => {
    // Build flexible payment object if current store is in the flexible list
    let flexiblePaymentObj = {};
    if (featureFlagDetails?.FlexibleTermAndRateStores == '1') {
      // Use persisted SLA role from ref (first approved role), ignore subsequent role params
      // This ensures the first SLA-approved role's limits are used until "Set to Default"
      const roleToUse = slaApprovedRoleRef.current || slaApprovedRoleParam || null;

      const limits = getFlexibleLimits(roleToUse);
      const initialRate = Number(initialAgrData);
      const initialTerm = Number(initialAgrTerm);

      const minRateDecrease = (initialRate * limits.rateMin) / 100;
      const maxRateIncrease = (initialRate * limits.rateMax) / 100;
      const minTermDecrease = (initialTerm * limits.termMin) / 100;
      const maxTermIncrease = (initialTerm * limits.termMax) / 100;
      const calculatedMinTerm = initialTerm - minTermDecrease;
      const calculatedMinRate = initialRate - minRateDecrease;

      flexiblePaymentObj = {
        flexiblePayment: {
          isFlexiblePayment: 'Y',
          flexibleMinTerm: Math.max(1, Math.ceil(calculatedMinTerm)).toFixed(2),
          flexibleMaxTerm: Math.ceil(initialTerm + maxTermIncrease).toFixed(2),
          flexibleMinRate: Math.max(1, calculatedMinRate).toFixed(2),
          flexibleMaxRate: (initialRate + maxRateIncrease).toFixed(2),
        }
      };
    }

    const req: any = {
      storeNumber: storeNumber,
      inventoryInfo: inventoriesValue,
      validateInventoryId: parseInt(validateInventoryIdValue),
      packageRequired: packageRequiredValue,
      packageName: packageNameValue,
      isCompetitorMatch: isCompetitorMatchValue,
      // Nulls are omitted rather than sent, since the pricing API rejects explicit nulls
      // for these optional fields (e.g. on the initial/default pricing call).
      ...(coworkerCheck == 'Y' && customerIdCheck != null ? { customerId: customerIdCheck } : {}),
      ...(packagePriceType != null ? { packagePriceType: packagePriceType } : {}),
      ...(agreementRateValue != null ? { agreementRate: agreementRateValue } : {}),
      ...(agreementTermValue != null ? { agreementTerm: agreementTermValue } : {}),
      ...(isExchangeAgreement && { isExchangeAgreement: isExchangeAgreement }),
      ...(isExchangeAgreement && { exchangeAgreementId: exchangeAgreementId }),
      ...flexiblePaymentObj,
        // Send overriddenTotalCost only when rate is overridden and term is null.
        ...(featureFlagDetails?.EnableMaxTRTOBasedAgrOverride == '1' && agreementRateValue != null && agreementTermValue == null && priceController.overriddenTotalCost != null && {
          overriddenTotalCost: priceController.overriddenTotalCost
        }),
      // RP-668: Send maxLegalTotalCost only when term is overridden, so the BE validates
      // against the legal ceiling instead of its own item-price TRTO. Not sent for rate
      // overrides or initial pricing calls (where agreementTermValue is null).
      ...(agreementTermValue != null && maximumAllowedTotalCostRef.current != null ? { maxLegalTotalCost: Number(maximumAllowedTotalCostRef.current) } : {}),
    };
    console.log('pricingCall request', req);

    const pricingResponse = await getPricingClientCall(req);
    // DE enforcement baseline: only captured from default (non rate/term-override) pricing
    // calls, so cart add/remove/package-selection changes update it but manual overrides don't.
    if (
      agreementRateValue == null &&
      agreementTermValue == null &&
      pricingResponse?.status == 200 &&
      pricingResponse?.data?.agreementPricing
    ) {
      setDeEnforcementBaseline({
        agreementRate: toFiniteNumber(pricingResponse.data.agreementPricing.agreementRate),
        agreementTerm: toFiniteNumber(pricingResponse.data.agreementPricing.agreementTerm),
        sacTotal: toFiniteNumber(pricingResponse.data.agreementPricing.cashPrice),
        totalCost: toFiniteNumber(pricingResponse.data.agreementPricing.agreementTotal),
      });
    }
    return pricingResponse;
  };

  // Clears the cached item-price TRTO from both the synchronous ref and AgreementContext.
  // Called when the final item is removed.
  const clearItemPriceTotalCost = () => {
    itemPriceTotalCostRef.current = undefined;
    setItemPriceTotalCost(undefined);
  };

  // Clears the legal/item-price TRTO ceiling from both the request ref and AgreementContext.
  // Called when the feature is disabled, legal-price data is invalid/fails, or all items are removed.
  const clearMaximumAllowedTotalCost = () => {
    maximumAllowedTotalCostRef.current = undefined;
    setMaximumAllowedTotalCost(undefined);
  };

  // Reads and caches agreementTotal from a successful pricing response as the item-price TRTO.
  // Called by parallel pricing, add-all/package-tag background flows, and package repricing so
  // storeMaximumAllowedTotalCost can compare this value with the legal-price TRTO.
  const storeItemPriceTotalCost = (responseData: any): number | undefined => {
    const agreementTotal = responseData?.agreementPricing?.agreementTotal;

    if (
      agreementTotal !== null &&
      agreementTotal !== undefined &&
      agreementTotal !== '' &&
      !isNaN(Number(agreementTotal))
    ) {
      // Cache the item-price TRTO so the legal ceiling can be compared against it later.
      const numericAgreementTotal = Number(agreementTotal);
      itemPriceTotalCostRef.current = numericAgreementTotal;
      setItemPriceTotalCost(numericAgreementTotal);
      return numericAgreementTotal;
    }

    clearItemPriceTotalCost();
    return undefined;
  };


  const legalPriceCall = async (inventoriesValue: { inventoryPriceId: number | string }[]) => {
    const req = buildLegalPriceRequest(storeNumber, inventoriesValue);
    return await getLegalPriceClientCall(req);
  };

  // Stores the greater of legal-price TRTO and item-price TRTO as the request validation ceiling.
  // Called after both totals are available in override repricing, parallel legal-price,
  // background legal-price, and package repricing flows before deriving the maximum term.
  const deriveMaximumAllowedTotalCost = (
    legalPriceTotalCost: string | number | null | undefined,
    itemPriceTotalCost: number | undefined
  ): number | undefined => {
    if (
      legalPriceTotalCost !== null &&
      legalPriceTotalCost !== undefined &&
      legalPriceTotalCost !== '' &&
      !isNaN(Number(legalPriceTotalCost)) &&
      itemPriceTotalCost !== undefined &&
      itemPriceTotalCost !== null
    ) {
      const legalPriceTotal = Number(legalPriceTotalCost);
      const maximumAllowedTotalCost = Math.max(legalPriceTotal, itemPriceTotalCost);
      maximumAllowedTotalCostRef.current = maximumAllowedTotalCost;
      setMaximumAllowedTotalCost(maximumAllowedTotalCost);
      return maximumAllowedTotalCost;
    }

    clearMaximumAllowedTotalCost();
    return undefined;
  };

  // RP-668 (parallel path): Wraps pricingCall so that, on add/remove trigger paths where the
  // full/current item list is ALREADY known at call time, pricingCall and legal/price fire
  // concurrently (Promise.allSettled). Used by addItem, salesLeadSingleAdder,
  // salesLeadPackageAdder, tagSingleInvCaller, and deleteItem.
  // newItemInventoryPriceIdForLegalPrice: addItem's newly added item is not yet part of
  // inventoriesValue (pricingCall resolves it separately via validateInventoryIdValue) — pass
  // its raw inventoryPriceId here so the legal/price request includes it too. Not needed for
  // other parallel call sites, whose inventoriesValue already includes every current item.
  // The Maximum Allowed Term is derived and persisted to state; rate-only overrides reuse the
  // already-stored value without a new call.
  // Feature flag gate: only fires legal/price when EnableMaxTRTOBasedAgrOverride == '1'.
  const pricingCallWithLegalPrice = async (
    inventoriesValue: any,
    validateInventoryIdValue: any,
    packageRequiredValue: any,
    agreementRateValue: any,
    agreementTermValue: any,
    isCompetitorMatchValue: any,
    packageNameValue: any,
    packagePriceType: any,
    slaApprovedRoleParam?: string | null,
    newItemInventoryPriceIdForLegalPrice?: number | string
  ) => {
    const isLegalPriceEnabled = featureFlagDetails?.EnableMaxTRTOBasedAgrOverride == '1';
    // Start a new tracker for this pricing/legal-price pair so older responses can be ignored.
    // Increment once per legal-price request so stale responses can be ignored.
    const legalPriceCallTrackerCount = ++legalPriceCallTrackerRef.current;
    pendingLegalPriceRef.current = null;

    if (!isLegalPriceEnabled) {
      // Clear all TRTO-derived values before pricingCall so stale enabled-flow data cannot
      // add maxLegalTotalCost to a feature-disabled request or affect term validation.
      clearItemPriceTotalCost();
      setLegalTotalCost(undefined);
      clearMaximumAllowedTotalCost();
      setMaximumAllowedTerm(undefined);
      const response = await pricingCall(
        inventoriesValue,
        validateInventoryIdValue,
        packageRequiredValue,
        agreementRateValue,
        agreementTermValue,
        isCompetitorMatchValue,
        packageNameValue,
        packagePriceType,
        slaApprovedRoleParam
      );
      return { response };
    }

    // Build the legal/price item list from what's already known at call time — no need to
    // wait for pricingCall's response since inventoriesValue is already complete/correct here.
    const itemsForLegalPrice: { inventoryPriceId: number | string }[] = [
      ...(inventoriesValue || []),
    ];
    if (newItemInventoryPriceIdForLegalPrice !== undefined && newItemInventoryPriceIdForLegalPrice !== null) {
      itemsForLegalPrice.push({ inventoryPriceId: newItemInventoryPriceIdForLegalPrice });
    }

    const [pricingSettled, legalPriceSettled] = await Promise.allSettled([
      pricingCall(
        inventoriesValue,
        validateInventoryIdValue,
        packageRequiredValue,
        agreementRateValue,
        agreementTermValue,
        isCompetitorMatchValue,
        packageNameValue,
        packagePriceType,
        slaApprovedRoleParam
      ),
      legalPriceCall(itemsForLegalPrice),
    ]);

    const response =
      pricingSettled.status === 'fulfilled' ? pricingSettled.value : undefined;

    let computedMaximumAllowedTerm: number | undefined = maximumAllowedTerm;

    if (response !== undefined && response.status == 200) {
      // Use the pricing response first, then layer the legal-price ceiling on top if it is still current.
      const fallbackAgreementTerm = response.data?.agreementPricing?.agreementTerm;
      const currentAgreementRate = response.data?.agreementPricing?.agreementRate;
      const itemPriceTotalCost = storeItemPriceTotalCost(response.data);

      // Bail out if a newer legal-price request already started after this one.
      if (legalPriceCallTrackerCount !== legalPriceCallTrackerRef.current) {
        return { response };
      }

      // AC7: legal/price failure (network error, non-200, or invalid data) must never block or
      // break the pricingCall flow — always fall back silently to the existing term ceiling.
      if (
        legalPriceSettled.status === 'fulfilled' &&
        legalPriceSettled.value !== undefined &&
        legalPriceSettled.value.status === 200 &&
        legalPriceSettled.value.data?.totalLegalPrice?.totalCost &&
        Number(currentAgreementRate)
      ) {
        const legalPriceTotalCost = legalPriceSettled.value.data.totalLegalPrice.totalCost;
        // Compare legal-price TRTO with item-price TRTO and persist whichever value is greater.
        const maximumAllowedTotalCost = deriveMaximumAllowedTotalCost(
          legalPriceTotalCost,
          itemPriceTotalCost
        );

        if (maximumAllowedTotalCost != null) {
          // Convert the selected TRTO ceiling into the maximum term allowed at the current rate.
          computedMaximumAllowedTerm = deriveMaximumAllowedTerm(
            String(maximumAllowedTotalCost),
            currentAgreementRate,
            Number(fallbackAgreementTerm)
          );
        } else {
          // Fall back to the pricing response term when either TRTO value cannot be compared.
          computedMaximumAllowedTerm = Number(fallbackAgreementTerm);
        }
        // Cache the raw total cost so call sites that reprice the same item set under a
        // different rate (no item change) can recompute the ceiling without a new legal call.
        setLegalTotalCost(legalPriceTotalCost);
      } else {
        // Legal/price failed or returned invalid data — fallback to existing term ceiling
        computedMaximumAllowedTerm = Number(fallbackAgreementTerm);
        setLegalTotalCost(undefined);
        clearMaximumAllowedTotalCost();
      }

      setMaximumAllowedTerm(computedMaximumAllowedTerm);
      // No pending background call for the parallel path — clear any stale ref.
      pendingLegalPriceRef.current = null;
    }

    return { response };
  };

  // RP-668 (sequential path): Used only by addAllItem and tagPackageInvCaller, where the item
  // list is resolved server-side (via PackageItemId) and is unknown until pricingCall's
  // response arrives. legal/price is fired here WITHOUT being awaited by the caller — it runs
  // silently in the background (no loader) using response.data.itemPricing[] as the item list.
  // Returns a promise (also stashed in pendingLegalPriceRef) that addedItem.tsx can await if
  // the user tries to override the term before this settles — see awaitPendingLegalPrice.
  const fetchLegalPriceAsync = (
    itemsForLegalPrice: { inventoryId: number | string; inventoryPriceId: number | string }[],
    currentAgreementRate: number | string,
    fallbackAgreementTerm: number | string,
    itemPriceTotalCost: number | undefined,
    legalPriceCallTrackerCount: number
  ): Promise<number | undefined> => {
    const promise = (async (): Promise<number | undefined> => {
      let computedMaximumAllowedTerm: number | undefined;
      try {
        const legalPriceResult = await legalPriceCall(itemsForLegalPrice);
        // If a newer request started while this one was in flight, drop this response.
        if (legalPriceCallTrackerCount !== legalPriceCallTrackerRef.current) {
          return maximumAllowedTerm;
        }
        if (
          legalPriceResult !== undefined &&
          legalPriceResult.status === 200 &&
          legalPriceResult.data?.totalLegalPrice?.totalCost &&
          Number(currentAgreementRate)
        ) {
          const legalPriceTotalCost = legalPriceResult.data.totalLegalPrice.totalCost;
          // Keep the greater of legal TRTO and item-price TRTO as the ceiling.
          const maximumAllowedTotalCost = deriveMaximumAllowedTotalCost(
            legalPriceTotalCost,
            itemPriceTotalCost
          );
          if (maximumAllowedTotalCost != null) {
            computedMaximumAllowedTerm = deriveMaximumAllowedTerm(
              String(maximumAllowedTotalCost),
              currentAgreementRate,
              Number(fallbackAgreementTerm)
            );
          } else {
            computedMaximumAllowedTerm = Number(fallbackAgreementTerm);
          }
          setLegalTotalCost(legalPriceTotalCost);
        } else {
          computedMaximumAllowedTerm = Number(fallbackAgreementTerm);
          setLegalTotalCost(undefined);
          clearMaximumAllowedTotalCost();
        }
      } catch (err) {
        // Network or API failure should not block pricing; fall back to the pricing term.
        if (legalPriceCallTrackerCount !== legalPriceCallTrackerRef.current) {
          return maximumAllowedTerm;
        }
        computedMaximumAllowedTerm = Number(fallbackAgreementTerm);
        setLegalTotalCost(undefined);
        clearMaximumAllowedTotalCost();
      }

      setMaximumAllowedTerm(computedMaximumAllowedTerm);
      // Clear the pending ref now that this call has settled
      pendingLegalPriceRef.current = null;

      return computedMaximumAllowedTerm;
    })();

    pendingLegalPriceRef.current = promise;
    return promise;
  };

  // RP-668: Passed to AddedItem so that, on sequential-path items only, a term override made
  // before the background legal/price call settles waits for it (loader shown in AddedItem)
  // instead of validating against a stale/fallback ceiling. For parallel-path items,
  // pendingLegalPriceRef is always null here, so this resolves immediately with no wait.
  const hasPendingLegalPrice = (): boolean => pendingLegalPriceRef.current !== null;

  const awaitPendingLegalPrice = async (): Promise<number | undefined> => {
    if (pendingLegalPriceRef.current) {
      return await pendingLegalPriceRef.current;
    }
    return maximumAllowedTerm;
  };

  const closeModal = (controller: any): any => {
    console.log('received controller', controller);
    if (controller == 'addAllPopUp') {
      setmodalController({ ...modalController, addAllPopUp: false });
      setLoaderBundle({ ...loaderBundle, masterLoader: false });
    } else if (controller == 'breakPackageCtrl') {
      setmodalController({ ...modalController, breakPackageCtrl: false });
      setLoaderBundle({ ...loaderBundle, masterLoader: false });
    } else if (controller == 'RateTermController') {
      setmodalController({ ...modalController, RateTermController: false });
    } else if (controller == 'breakPopup') {
      setmodalController({ ...modalController, breakPopup: false });
    }
  };

  const deleteItem = () => {
    console.log('dsdcd sdcvfdf itemArray fcv', itemArray);

    if (itemArray !== undefined && itemArray.length > 0) {
      console.log('Data Inside invDeleteId use effect', deleteId.invDeleteId);
      let UpdatedArray: any = [];
      itemArray.map((deleteObject: any, index: any) => {
        if (
          parseInt(deleteObject.inventoryId) === parseInt(deleteId.invDeleteId)
        ) {
          UpdatedArray = itemArray.filter((item, filterIndex) => {
            console.log('filter copy item', item);
            return filterIndex != index;
          });
          //UpdatedArray = itemArray.splice(index, 1);
          console.log('Newly Updated Array', UpdatedArray);
          setItemArray(UpdatedArray);
        }
      });
      if (UpdatedArray.length <= 1) {
        console.log('reached null received package');
        setselectedPackage('');
        setstoreSelectedPackage('');
        setreceivedpackage('');
        setsearchCriteria({ ...searchCriteria, packageTypeval: '' });
      }
      // setitemArrayContext(UpdatedArray);
      setitemArrayData(UpdatedArray);

      let response: any;
      if (UpdatedArray.length > 0) {
        console.log('Inside if');
        const selectedPackageProvider =
          UpdatedArray.length > 1 ? selectedPackage : '';
        console.log('selectedPackageProvider logger', selectedPackageProvider);

        const triggerAPI = async () => {
          const pricingResult = await pricingCallWithLegalPrice(//Once the Inventory is deleted form the Added Item it will be triggered
            UpdatedArray,
            null,
            false,
            null,
            null,
            false,
            selectedPackageProvider,
            null
          );
          response = pricingResult.response;
          // setmasterLoader(false);
          setLoaderBundle({ ...loaderBundle, masterLoader: false });

          console.log('Inside Use Effect of invDeleteId', response);
          console.log('Came inside result if condition');
          // setaddedItemContext(response.data);
          setaddedItem(response.data);

          if (response.data !== undefined && response.status == 200) {
            setinitialAgrData(response.data.agreementPricing.agreementRate);
            storeDefaultAgreementTerm(response.data); // Item-deletion repricing flow
            setShowAddedItem(true);
            setIsPackage(false);
            setfooterControlData(false);
            setInternalContextProvider(response.data);
            if (
              response.data.packageInformation.packageTypeList !== null &&
              Object.keys(response.data.packageInformation.packageTypeList)
                .length !== 0 &&
              response.data.packageInformation.packageTypeList !== '' && selectedPackageProvider !== ADD_ON_PACKAGE
            ) {
              if (selectedPackageProvider == '') {
                setpackageCriteria(
                  response.data.packageInformation.packageTypeList[0]
                    .packageCriteria
                );
              } else {
                const filteredCriteria =
                  response.data.packageInformation.packageTypeList.filter(
                    (item, index) => {
                      if (selectedPackageProvider == item.packageName) {
                        return item;
                      }
                    }
                  );
                setpackageCriteria(filteredCriteria[0].packageCriteria);
              }
              setreceivedpackage(response.data.itemPricing[0].packageName);
              setsearchCriteria({
                ...searchCriteria,
                packageTypeval: response.data.itemPricing[0].packageName,
              });
            }
            else if (selectedPackageProvider == ADD_ON_PACKAGE) {
              setpackageCriteria({
                packageName: ADD_ON_PACKAGE,
              });
            }
            else {
              setpackageCriteria(null);
            }
            let tireController = false;
            const responseHolder = response.data.itemPricing;
            for (let i = 0; i < responseHolder.length; i++) {
              if (
                responseHolder[i].rmsItemNumber == '200012120' ||
                responseHolder[i].rmsItemNumber == '200012121' ||
                responseHolder[i].rmsItemNumber == '200013177' ||
                responseHolder[i].rmsItemNumber == '200012118' ||
                responseHolder[i].rmsItemNumber == '200013350' ||
                responseHolder[i].rmsItemNumber == '200012119'
              ) {
                tireController = true;
                // settireController(true);
                break;
              }
            }
            const getBreakPkgData: any = [];
            response.data.itemPricing.map((obj: any) => {
              if (
                obj.packagePriceId !== null &&
                obj.packagePriceId !== 'null'
              ) {
                getBreakPkgData.push(Number(obj.packagePriceId));
              }
            });
            const uniqueBreakData = [...new Set(getBreakPkgData)];
            setbrokenPackageData(uniqueBreakData);
            ContextSkeleton(
              response.data,
              UpdatedArray,
              setTestInput,
              customerId,
              priceController,
              competitorDDValue,
              tireController
            );
            // Store latest agreementTotal from response as overriddenTotalCost
            if (featureFlagDetails?.EnableMaxTRTOBasedAgrOverride == '1') {
              const latestTotal = response.data.agreementPricing?.agreementTotal;
              if (latestTotal != null) {
                setpriceController(prev => ({
                  ...prev,
                  overriddenTotalCost: parseFloat(latestTotal)
                }));
              }
            }
            setpackageListData(
              response.data.packageInformation.packageTypeList
            );
          } else if (response.status == 400) {
            setmodalController({
              ...modalController,
              itemPricingFail: true,
            });
            setPricexeptionMessage(response.data.errors[0].error);
          }
        };
        triggerAPI();
        setcompetitorDDValue(null);
        setisCompCheck(false);
        setselectedCompetitor(undefined);
        setpriceController({ ...priceController, CompetitorCheck: false });
        //childFunc.current.resetCompetitorData();
      } else {
        // setmasterLoader(false);
        setIsPackage(false);
        setLoaderBundle({ ...loaderBundle, masterLoader: false });
        setisCompCheck(false);
        console.log('Came inside deep else');
        setInternalContextProvider(undefined);
        setShowAddedItem(false);
        setfooterControlData(true);
        setselectedCompetitor(undefined);
        setproofFileName(undefined);
        setpackageCriteria(null);
        setselectedPackage('');
        setstoreSelectedPackage('');
        props.setItemSearchCompleted(false);
        setbrokenPackageData([]);
        // With no items left, cancel pending legal pricing, invalidate stale responses, and clear all TRTO ceilings.
        pendingLegalPriceRef.current = null;
        legalPriceCallTrackerRef.current += 1;
        setLegalTotalCost(undefined);
        setMaximumAllowedTerm(undefined);
        clearItemPriceTotalCost();
        clearMaximumAllowedTotalCost();
        // Clear SLA approved role when all items are removed (fresh start)
        slaApprovedRoleRef.current = null;
      }
    } else {
      console.log('Came inside else');
      setInternalContextProvider(undefined);
      setShowAddedItem(false);
      setfooterControlData(true);
      setbrokenPackageData([]);
      setLoaderBundle({ ...loaderBundle, masterLoader: false });
      // With no items left, cancel pending legal pricing, invalidate stale responses, and clear all TRTO ceilings.
      pendingLegalPriceRef.current = null;
      legalPriceCallTrackerRef.current += 1;
      setLegalTotalCost(undefined);
      setMaximumAllowedTerm(undefined);
      clearItemPriceTotalCost();
      clearMaximumAllowedTotalCost();
      // Clear SLA approved role when all items are removed (fresh start)
      slaApprovedRoleRef.current = null;
    }
    const copyNum = deleteId.invDeleteId;

    const resultArr = bucketCopy.filter((data, index) => {
      return bucketCopy.indexOf(data) === index;
    });

    console.log('copy before map', bucketCopy);
    console.log('copyNum', copyNum);

    const refinedTableData: any = [];
    gridData.map((obj: any, index: any) => {
      if (obj.inventoryId !== copyNum) {
        refinedTableData.push(obj);
      }
    });

    resultArr.map((obj: any, index: any) => {
      console.log('copy map obj', obj);
      if (obj.inventoryId == copyNum) {
        const copyTableData = refinedTableData;
        copyTableData.push(obj);
        setGridData(copyTableData);

        const newCopy = bucketCopy.filter((item, filterIndex) => {
          console.log('filter copy item', item);
          return filterIndex != index;
        });

        console.log('copy after map', newCopy);
        setBucketCopy(newCopy);
        setcopyArrayData(newCopy);
      }
    });
  };

  const acceptBreakPackage = () => {
    deleteItem();
    setmodalController({ ...modalController, breakPackageCtrl: false });
  };

  const declineBreakPackage = () => {
    setLoaderBundle({ ...loaderBundle, masterLoader: false });
    setmodalController({ ...modalController, breakPackageCtrl: false });
  };

  const searchClick = async (value: any, source: any) => {
    if (source == 'searchButtonClick') {
      setpayloadSetNumber(1);
      setOffSetValue(1);
      setLoaderBundle({
        ...loaderBundle,
        Gridloader: true,
        loaderController: true,
      });
      sethasMore(true);
    } else if (source == 'searchButtonNotClick') {
      setscrollLoader(true);
    }
    console.log('thsg6rd8z4vsc5', value);

    const currentStore = sessionStorage.getItem('storeNumber');
    const req: any = {
      storeNumbers: [currentStore],
      itemNumber: value.itemNo == '' ? null : [value.itemNo],
      serialNumber: value.serialNo.trim(),
      bracket: value.bracket.trim(),
      brand: value.brand.trim(),
      modelNumber: value.model.trim(),
      statusId: value.statusId,
      subStatusId: salesLeadId == null ? [2] : [2, 6],
      conditionId:
        value.conditionId == '0' || value.conditionId == null
          ? null
          : parseInt(value.conditionId),
      department: value.departments,
      subDepartment: value.subDepartments,
      packageName: value.packageTypeval !== ADD_ON_PACKAGE ? value.packageTypeval : null,
      setNumber: source == 'searchButtonClick' ? 0 : payloadSetNumber,
      isActivePriceTag: true,
    };
    console.log('defined payload', req);

    // setSearchCriteriaContext(req);
    //setsearchCriteria(req);
    // if(salesLeadId !== null){
    //   setSalesLeadData({...req,itemNo:value.itemNo});
    // }// removed this
    try {
      const response: any = await getInventorySearch(req);

      if (salesLeadId !== null) {
        setSalesLeadData({
          packageTypeval: value.packageTypeval,
          itemNo: value.itemNo,
          model: value.model,
        });
        setsearchCriteria({
          ...searchCriteria,
          packageTypeval: value.packageTypeval,
          itemNo: value.itemNo,
          model: value.model,
        });
        setselectedPackage(value.packageTypeval);
        setstoreSelectedPackage(value.packageTypeval);
      }
      if (response.status == 400 || response.status == 500) {
        // setinternalServerController(true);
        const errorMessage = response.data?.errors?.[0]?.error;
        const packageName = req.packageName;

        if (errorMessage === `No package types in this packageName :${packageName}`) {
          setPackageNotAvailableOpen(true);
        } else {
          setSomethingWentWrongPopup(true); // Show the error popup
        }

        setresultController({
          ...resultControllerObj,
          internalServerController: true,
        });
        // setloaderController(false);
        setLoaderBundle({ ...loaderBundle, loaderController: false });
      } else if (response.status == 200 && response.data.response.length > 0) {
        // setsearchResultContext(response.data.response);
        setItemSearchDuplicate(prevState => {
          const newItems = {};
          response.data.response.forEach(item => {
            newItems[item.inventoryId] = item;
          });
          return { ...prevState, ...newItems };
        });
        if (source == 'searchButtonNotClick') {
          setpayloadSetNumber(payloadSetNumber + 1);
          setOffSetValue(payloadSetNumber + 1);
        }
        let furtherFilteredData: any = [];
        if (itemArray.length > 0) {
          console.log('reached if of search');
          let pushMe = false;
          response.data.response.map((filteredDataObj: any, index: any) => {
            console.log('times of trigger', index);

            for (let i = 0; i < itemArray.length; i++) {
              console.log('itemArrayData', itemArrayData);
              console.log(
                'filteredDataObj.inventoryId',
                filteredDataObj.inventoryId
              );

              if (
                itemArray[i].inventoryId !==
                parseInt(filteredDataObj.inventoryId)
              ) {
                console.log('reached once true');
                pushMe = true;
              } else {
                console.log('reached break statement');
                pushMe = false;
                break;
              }
            }

            if (pushMe) {
              console.log('times reached fbdfbdfzBf');

              furtherFilteredData.push(filteredDataObj);
            }
          });
        } else {
          console.log('reached else of sr');
          furtherFilteredData = response.data.response;
        }
        if (furtherFilteredData.length <= 0) {
          setGridData([]);
          setresultController({ ...resultControllerObj, controlRecord: true });

          setLoaderBundle({ ...loaderBundle, loaderController: false }); //The loader is disabled here
        } else {
          if (source == 'searchButtonNotClick') {
            setsearchResult([...gridData, ...furtherFilteredData]);
            setGridData([...gridData, ...furtherFilteredData]);
          } else {
            setsearchResult(furtherFilteredData); //This will be storing the response of the inventory search API
            setLoaderBundle({ ...loaderBundle, loaderController: false }); //The loader is disabled here
            console.log('Response from api', response);

            setGridData(furtherFilteredData); //This will assign the API result to get the Search Result grid get load.
          }
          setresultController(resultControllerObj);
        }
        //setsearchResult(response.data.response);

        // setloaderController(false);
        //setLoaderBundle({ ...loaderBundle, loaderController: false });

        console.log('Response from api', response);

        const ApiResult: any = response.data.response;
        console.log('response', ApiResult);
        console.log('response-array', ApiResult[0]);
      } else if (response.data.response.length <= 0) {
        if (source == 'searchButtonClick') {
          setGridData([]);
          setresultController({ ...resultControllerObj, controlRecord: true });
          setLoaderBundle({ ...loaderBundle, loaderController: false });
        } else if (source == 'searchButtonNotClick') {
          sethasMore(false);
          setLoaderBundle({ ...loaderBundle, loaderController: false });
        }
      }
    } catch {
      setSomethingWentWrongPopup(true);
      setresultController({
        ...resultControllerObj,
        internalServerController: true,
      });
      setLoaderBundle({ ...loaderBundle, loaderController: false });
    }
  };

  const gridCallMethod = () => {
    console.log('Came inside Grid Method');

    if (gridData !== undefined && gridData.length > 0) {
      console.log('Inside table bind', gridData);
      return (
        <div>
          <Typography className={`${classes.title} ${classes.mt3}`}>
            {t("Search Results")}
          </Typography>
          <Card className={`${classes.card} ${classes.mb4} ${classes.p3}`}>
            <CardContent className={classes.p0}>
              <DynamicGridComponent
                items={gridData}
                customerVerifyLevel={verifyLevel != undefined ? verifyLevel : getCustomerResponse?.GetApproval?.value?.customerApprovalDetails?.verifyLevel}
                customerApprovalDetails={customerApprovalDetails != undefined ? customerApprovalDetails : getCustomerResponse?.GetApproval?.value?.customerApprovalDetails}
                customerDetails={getCustomerResponse?.GetCustomer}
                productExclusions={getCustomerResponse?.GetApproval?.value?.customerApprovalDetails?.productExclusions}
                orderBy="loanerAgreement"
                handleActionType={addItem}
                order={sortDirection.ASC}
                throwStyle={classes}
                triggerSearch={searchClick}
                reveiveHasMore={hasMore}
                reveivescrollLoader={scrollLoader}
              ></DynamicGridComponent>
            </CardContent>
          </Card>
        </div>
      );
    } else if (resultController.internalServerController) {
      return (
        <ExceptionController
          throwExceptionDecider="Went Wrong"
          throwStyle={classes}
        />
      );
    } else if (resultController.controlRecord) {
      return (
        <ExceptionController
          throwExceptionDecider="No Records"
          throwStyle={classes}
        />
      );
    } else if (resultController.controlEmptyRecord) {
      return (
        <ExceptionController
          throwExceptionDecider="No Item"
          throwStyle={classes}
        />
      );
    }
  };

  const addAllItem = async () => {
    setmodalController({ ...modalController, addAllPopUp: false });

    // setmasterLoader(true);
    setLoaderBundle({ ...loaderBundle, masterLoader: true });

    //setItemArray([]);
    // RP-668 (sequential path): this package's item list is resolved server-side via
    // PackageItemId and is unknown until this pricingCall response arrives, so legal/price
    // cannot fire in parallel here. It is fired in the background (no loader) right after —
    // see fetchLegalPriceAsync — instead of being awaited before the loader hides.
    const response = await pricingCall( // add all item in the package flow
      [],
      PackageItemId,
      true,
      null,
      null,
      false,
      '',
      null
    );
    setLoaderBundle({ ...loaderBundle, masterLoader: false });

    if (
      response !== undefined &&
      response.status == 200 &&
      featureFlagDetails?.EnableMaxTRTOBasedAgrOverride == '1'
    ) {
      const itemPriceTotalCost = storeItemPriceTotalCost(response.data);
      // Increment once per legal-price request so stale responses can be ignored.
      const legalPriceCallTrackerCount = ++legalPriceCallTrackerRef.current;
      const itemsForLegalPrice = (response.data?.itemPricing || []).map((item: any) => ({
        inventoryId: item.inventoryId,
        inventoryPriceId: item.inventoryPriceId,
      }));
      // Fire-and-forget: not awaited, so the loader above does not wait for this.
      // This path runs after pricing has already returned, so legal-price can resolve in the background.
      fetchLegalPriceAsync(
        itemsForLegalPrice,
        response.data?.agreementPricing?.agreementRate,
        response.data?.agreementPricing?.agreementTerm,
        itemPriceTotalCost,
        legalPriceCallTrackerCount
      );
    }

    console.log('add all item popup', response);
    if (
      response.status == 200 &&
      response.data.packageInformation.packagePriceInfo?.packagePrice?.length == 1
    ) {
      // setpackageDataContext(response.data.packageInformation);
      setisCompCheck(false);
      setbrokenPackageData([]);
      setselectedCompetitor(undefined);
      setIsPackage(true);
      setpackageListData(response.data.packageInformation.packageTypeList);
      setinitialAgrData(response.data.agreementPricing.agreementRate);
      storeDefaultAgreementTerm(response.data); // Add-all standard package flow

      // setmasterLoader(false);
      //setLoaderBundle({ ...loaderBundle, masterLoader: false });

      setreceivedpackage(response.data.itemPricing[0].packageName);
      setselectedPackage(response.data.itemPricing[0].packageName);
      setstoreSelectedPackage(response.data.itemPricing[0].packageName);
      console.log(
        'response.data.itemPricing[0].packageName',
        response.data.itemPricing[0].packageName
      );
      setsearchCriteria({
        ...searchCriteria,
        packageTypeval: response.data.itemPricing[0].packageName,
      });

      let newItemArray: any = [];
      if (response.data !== undefined) {
        response.data.itemPricing.map((value: any) => {
          console.log('individual inv id of package', value.inventoryId);

          newItemArray = [
            ...newItemArray,
            {
              inventoryId: Number(value.inventoryId),
              inventoryPriceId: Number(value.inventoryPriceId),
            },
          ];
        });

        setfooterControlData(false);

        if (
          response.data.packageInformation.packageTypeList !== null &&
          Object.keys(response.data.packageInformation.packageTypeList)
            .length !== 0 &&
          response.data.packageInformation.packageTypeList !== ''
        ) {
          setpackageCriteria(
            response.data.packageInformation.packageTypeList[0].packageCriteria
          );
          setreceivedpackage(response.data.itemPricing[0].packageName);
          setsearchCriteria({
            ...searchCriteria,
            packageTypeval: response.data.itemPricing[0].packageName,
          });
        } else {
          setpackageCriteria(null);
        }
      }
      setItemArray(newItemArray);
      // setitemArrayContext(newItemArray);
      setitemArrayData(newItemArray);

      console.log('Item Array in package', newItemArray);
      let tireController = false;
      const responseHolder = response.data.itemPricing;
      for (let i = 0; i < responseHolder.length; i++) {
        if (
          responseHolder[i].rmsItemNumber == '200012120' ||
          responseHolder[i].rmsItemNumber == '200012121' ||
          responseHolder[i].rmsItemNumber == '200013177' ||
          responseHolder[i].rmsItemNumber == '200012118' ||
          responseHolder[i].rmsItemNumber == '200013350' ||
          responseHolder[i].rmsItemNumber == '200012119'
        ) {
          tireController = true;
          settireController(true);
          break;
        }
      }
      // provideContext(response.data, newItemArray, tireController);
      ContextSkeleton(
        response.data,
        newItemArray,
        setTestInput,
        customerId,
        priceController,
        competitorDDValue,
        tireController
      );

      setInternalContextProvider(response.data);

      // setGridData([...tabledata, copy]);
      const copyTableData = gridData;

      // setGridData([...tabledata, obj]);
      bucketCopy.map((obj: any) => {
        copyTableData.push(obj);
      });
      setGridData(copyTableData);
      // setcopy([]);

      let emptyCopy: any = [];
      if (response.data !== undefined) {
        response.data.itemPricing.map((obj: any) => {
          gridData.map((value: any) => {
            if (value.inventoryId === obj.inventoryId) {
              emptyCopy = [...emptyCopy, value];
            }
          });
        });
        setBucketCopy(emptyCopy);
        // setcopyArrayContext(emptyCopy);
        setcopyArrayData(emptyCopy);
      }

      console.log('the empty copy is', emptyCopy);

      console.log('before tab data values', gridData);

      let emptyTableData: any = [];
      emptyTableData = gridData.filter((object) => !emptyCopy.includes(object));
      console.log('exptyTableData', emptyTableData);
      setGridData(emptyTableData);
      if (response.data !== undefined) {
        // setaddedItemContext(response.data);
        setaddedItem(response.data);

        setShowAddedItem(true);
        // setaddAllPopUp(false);
        setmodalController({ ...modalController, addAllPopUp: false });
      }
    }
    else if (response.data.itemPricing[0].packageName == ADD_ON_PACKAGE.toUpperCase()) {
      setisCompCheck(false);
      setisPackageFlow(false);
      setIsPackage(true);
      setopenPackagePriceTag(false);
      setpackageCriteria([]);
      setpackageListData([])

      setinitialAgrData(response.data.agreementPricing.agreementRate);
      storeDefaultAgreementTerm(response.data); // Add-all Add-On Package flow
      setreceivedpackage(ADD_ON_PACKAGE);
      setselectedPackage(ADD_ON_PACKAGE);
      setstoreSelectedPackage(ADD_ON_PACKAGE);
      setsearchCriteria({
        ...searchCriteria,
        packageTypeval: ADD_ON_PACKAGE,
      });
      let emptyCopy: any = [];
      if (response.data !== undefined) {
        response.data.itemPricing.map((obj: any) => {
          gridData.map((value: any) => {
            if (value.inventoryId === obj.inventoryId) {
              emptyCopy = [...emptyCopy, value];
            }
          });
        });
        setBucketCopy(emptyCopy);
        // setcopyArrayContext(emptyCopy);
        setcopyArrayData(emptyCopy);
      }
      let newItemArray: any = [];
      if (response.data !== undefined) {
        response.data.itemPricing.map((value: any) => {
          console.log('individual inv id of package', value.inventoryId);

          newItemArray = [
            ...newItemArray,
            {
              inventoryId: Number(value.inventoryId),
              inventoryPriceId: Number(value.inventoryPriceId),
            },
          ];
        });

        setfooterControlData(false);
        setpackageCriteria(null);

      }
      setItemArray(newItemArray);
      setitemArrayData(newItemArray);
      ContextSkeleton(
        response.data,
        newItemArray,
        setTestInput,
        customerId,
        priceController,
        competitorDDValue,
        tireController
      );
      setInternalContextProvider(response.data);
      let emptyTableData: any = [];
      /* Below code is used to filter the records in grid other an the  getITemPricing response  */
      emptyTableData = gridData.filter((object) => !emptyCopy.includes(object));
      console.log('exptyTableData', emptyTableData);
      setGridData(emptyTableData);
      if (response.data !== undefined) {
        // setaddedItemContext(response.data);
        setaddedItem(response.data);

        setShowAddedItem(true);
        // setaddAllPopUp(false);
        setmodalController({ ...modalController, addAllPopUp: false });
      }
    }
    else if (
      response.status === 200 &&
      response.data.packageInformation.packagePriceInfo.packagePrice.length >
      1 &&
      isChoosePriceConfig == '1'
    ) {
      const modalInvPopupator: any = [];
      response.data.itemPricing.map((obj) => {
        modalInvPopupator.push({
          inventoryNumber: obj.inventoryNumber,
          inventoryName: obj.inventoryName,
        });
      });
      console.log('dfdvfd dcfv542 modalInvPopupator', modalInvPopupator);
      setisPackageFlow(true);
      setpackageInvPopulator(modalInvPopupator);
      setopenPackagePriceTag(true);
      setpackageBlueLabel(
        response.data.packageInformation.packagePriceInfo.packageType
      );
      if (
        response.data.packageInformation.packagePriceInfo.packagePrice[0] ===
        'ACTIVE'
      ) {
        setPackageleftValue(
          response.data.packageInformation.packagePriceInfo.packagePrice[1]
        );
        setPackagerightValue(
          response.data.packageInformation.packagePriceInfo.packagePrice[0]
        );
      } else {
        setPackageleftValue(
          response.data.packageInformation.packagePriceInfo.packagePrice[0]
        );
        setPackagerightValue(
          response.data.packageInformation.packagePriceInfo.packagePrice[1]
        );
      }
    } else if (
      response.status === 200 &&
      response.data.packageInformation.packagePriceInfo.packagePrice.length >
      1 &&
      isChoosePriceConfig == '0'
    ) {
      setisCompCheck(false);
      setselectedCompetitor(undefined);
      setIsPackage(true);
      setbrokenPackageData([]);
      setpackageListData(response.data.packageInformation.packageTypeList);
      setinitialAgrData(response.data.agreementPricing.agreementRate);
      storeDefaultAgreementTerm(response.data); // Add-all package flow without price tag selection

      // setmasterLoader(false);
      //setLoaderBundle({ ...loaderBundle, masterLoader: false });

      setreceivedpackage(response.data.itemPricing[0].packageName);
      setselectedPackage(response.data.itemPricing[0].packageName);
      setstoreSelectedPackage(response.data.itemPricing[0].packageName);
      console.log(
        'response.data.itemPricing[0].packageName',
        response.data.itemPricing[0].packageName
      );
      setsearchCriteria({
        ...searchCriteria,
        packageTypeval: response.data.itemPricing[0].packageName,
      });

      let newItemArray: any = [];
      if (response.data !== undefined) {
        response.data.itemPricing.map((value: any) => {
          console.log('individual inv id of package', value.inventoryId);

          newItemArray = [
            ...newItemArray,
            {
              inventoryId: Number(value.inventoryId),
              inventoryPriceId: Number(value.inventoryPriceId),
            },
          ];
        });

        setfooterControlData(false);

        if (
          response.data.packageInformation !== null &&
          Object.keys(response.data.packageInformation).length !== 0 &&
          response.data.packageInformation !== ''
        ) {
          setpackageCriteria(
            response.data.packageInformation[0].packageCriteria
          );
          setreceivedpackage(response.data.itemPricing[0].packageName);
          setsearchCriteria({
            ...searchCriteria,
            packageTypeval: response.data.itemPricing[0].packageName,
          });
        } else {
          setpackageCriteria(null);
        }
      }
      setItemArray(newItemArray);
      // setitemArrayContext(newItemArray);
      setitemArrayData(newItemArray);

      console.log('Item Array in package', newItemArray);
      let tireController = false;
      const responseHolder = response.data.itemPricing;
      for (let i = 0; i < responseHolder.length; i++) {
        if (
          responseHolder[i].rmsItemNumber == '200012120' ||
          responseHolder[i].rmsItemNumber == '200012121' ||
          responseHolder[i].rmsItemNumber == '200013177' ||
          responseHolder[i].rmsItemNumber == '200012118' ||
          responseHolder[i].rmsItemNumber == '200013350' ||
          responseHolder[i].rmsItemNumber == '200012119'
        ) {
          tireController = true;
          settireController(true);
          break;
        }
      }
      // provideContext(response.data, newItemArray, tireController);
      ContextSkeleton(
        response.data,
        newItemArray,
        setTestInput,
        customerId,
        priceController,
        competitorDDValue,
        tireController
      );

      setInternalContextProvider(response.data);

      // setGridData([...tabledata, copy]);
      const copyTableData = gridData;

      // setGridData([...tabledata, obj]);
      bucketCopy.map((obj: any) => {
        copyTableData.push(obj);
      });
      setGridData(copyTableData);
      // setcopy([]);

      let emptyCopy: any = [];
      if (response.data !== undefined) {
        response.data.itemPricing.map((obj: any) => {
          gridData.map((value: any) => {
            if (value.inventoryId === obj.inventoryId) {
              emptyCopy = [...emptyCopy, value];
            }
          });
        });
        setBucketCopy(emptyCopy);
        // setcopyArrayContext(emptyCopy);
        setcopyArrayData(emptyCopy);
      }

      console.log('before tab data values', gridData);

      let emptyTableData: any = [];
      emptyTableData = gridData.filter((object) => !emptyCopy.includes(object));
      console.log('exptyTableData', emptyTableData);
      setGridData(emptyTableData);
      if (response.data !== undefined) {
        // setaddedItemContext(response.data);
        setaddedItem(response.data);

        setShowAddedItem(true);
        // setaddAllPopUp(false);
        setmodalController({ ...modalController, addAllPopUp: false });
      }
    } else if (response.status == 400) {
      // setpackageExceptionController(true);
      setmodalController({
        ...modalController,
        itemPricingFail: true,
      });
      setPricexeptionMessage(response.data.errors[0].error);
      // setmasterLoader(false);
      setLoaderBundle({ ...loaderBundle, masterLoader: false });
    }

  };
  const declineAdding = () => {
    setmodalController({
      ...modalController,
      addAllPopUp: false,
      breakPopup: false,
    });
    // setbreakPopup(false);
    if (itemArray.length > 0) {
      setShowAddedItem(true);
    } else {
      setShowAddedItem(false);
      setInternalContextProvider({});
    }

    // setInternalContextProvider({});
  }; //PS-12

  const addItem = async (
    departmentsEn: any,
    itemid: any,
    index: any,
    status: any,
    invNumber: any,
    inventoryPriceId: any,

  ) => {
    // setmasterLoader(true);


    const pricingCallController = await addController(invNumber, status);
    if (pricingCallController) {
      setLoaderBundle({ ...loaderBundle, masterLoader: true });

      setcollectIndex(index);
      let constructedItemArray = [];
      if (isPackage) {
        constructedItemArray = [];
      } else {
        constructedItemArray = itemArray;
      }
      let packageParameter = '';
      if (constructedItemArray.length > 0 || selectedPackage == ADD_ON_PACKAGE) {
        packageParameter = selectedPackage;
      }
      // RP-668: pricingCall and legal/price fire in parallel here. constructedItemArray only
      // has items already in the agreement — the item currently being added isn't in it yet
      // (pricingCall resolves it separately via itemid/validateInventoryIdValue), so its
      // inventoryPriceId is passed explicitly for the legal/price request.
      const { response } = await pricingCallWithLegalPrice(//Once the user clicks the Inventory from the Grid It will be Triggered.(Data Not Setted to InternalContext)
        constructedItemArray,
        itemid,
        false,
        null,
        null,
        false,
        packageParameter,
        null,
        null,
        inventoryPriceId
      );
      setLoaderBundle({ ...loaderBundle, masterLoader: false });

      console.log('raw response', response);
      // setaddedItemContext(response.data);
      setaddedItem(response.data);

      console.log('Respoooooonse', response.data);
      if (response.data && response.status == 200) {
        setAddGetItemPrice(response.data)
      }

      let newItemArray: any = [];
      if (
        response.data !== undefined &&
        response.status == 200 &&
        response.data.isPackage === true
      ) {
        // setShowAddedItem(false);
        // setaddAllPopUp(true);
        setmodalController({ ...modalController, addAllPopUp: true });

        setPackageItemId(parseInt(itemid));
        setPackagePricingResponse(response);
      } else if (response.status == 200 && response.data.isPackage === false) {
        // if(itemArray.length >= 1){
        //   childFunc.current.resetCompetitorData();
        // }
        const allowPricePopulate =
          isChoosePriceConfig == '1' ? await pricePopulator(response) : true;
        if (allowPricePopulate) {
          setisCompCheck(false);
          setselectedCompetitor(undefined);
          let constructedItemArray = [];
          if (isPackage) {
            constructedItemArray = [];
          } else {
            constructedItemArray = itemArray;
          }
          let tireController: any = false;
          const responseHolder = response.data.itemPricing;
          for (let i = 0; i < responseHolder.length; i++) {
            if (
              responseHolder[i].rmsItemNumber == '200012120' ||
              responseHolder[i].rmsItemNumber == '200012121' ||
              responseHolder[i].rmsItemNumber == '200013177' ||
              responseHolder[i].rmsItemNumber == '200012118' ||
              responseHolder[i].rmsItemNumber == '200013350' ||
              responseHolder[i].rmsItemNumber == '200012119'
            ) {
              tireController = true;
              settireController(true);
              break;
            }
          }
          newItemArray = [
            ...constructedItemArray,
            {
              inventoryId: Number(itemid),
              inventoryPriceId: Number(inventoryPriceId),
            },
          ];
          setinitialAgrData(response.data.agreementPricing.agreementRate);
          storeDefaultAgreementTerm(response.data); // item-add flow

          ContextSkeleton(
            response.data,
            newItemArray,
            setTestInput,
            customerId,
            priceController,
            competitorDDValue,
            tireController
          );
          // Store latest agreementTotal from response as overriddenTotalCost
          if (featureFlagDetails?.EnableMaxTRTOBasedAgrOverride == '1') {
            const latestTotal = response.data.agreementPricing?.agreementTotal;
            if (latestTotal != null) {
              setpriceController(prev => ({
                ...prev,
                overriddenTotalCost: parseFloat(latestTotal)
              }));
            }
          }
          setIsPackage(false);
          console.log('newItemArray in add item', newItemArray);

          setItemArray(newItemArray);
          console.log('reached setitemArrayData');
          setpackageListData(response.data.packageInformation.packageTypeList);
          console.log('reached setpackageData');

          console.log(
            'response.data.packageInformation',
            response.data.packageInformation
          );
          setitemArrayData(newItemArray);
          setfooterControlData(false);
          if (isPackage) {
            console.log('reached expected');
            console.log('reached expected copy', bucketCopy);
            const copyTableData = gridData;
            bucketCopy.map((obj: any) => {
              copyTableData.push(obj);
            });
            setGridData(copyTableData);
          }
          if (
            response.data.packageInformation.packageTypeList != null &&
            Object.keys(response.data.packageInformation.packageTypeList)
              .length !== 0 &&
            response.data.packageInformation.packageTypeList != ''
          ) {
            if (packageParameter == '') {
              setpackageCriteria(
                response.data.packageInformation.packageTypeList[0]
                  .packageCriteria
              );
            } else {
              const filteredCriteria =
                response.data.packageInformation.packageTypeList.filter(
                  (item, index) => {
                    if (packageParameter == item.packageName) {
                      return item;
                    }
                  }
                );
              setpackageCriteria(filteredCriteria[0].packageCriteria);
            }
            setreceivedpackage(response.data.itemPricing[0].packageName);
            setsearchCriteria({
              ...searchCriteria,
              packageTypeval: response.data.itemPricing[0].packageName,
            });
            setselectedPackage(response.data.itemPricing[0].packageName);
            setstoreSelectedPackage(response.data.itemPricing[0].packageName);
          }
          else if (selectedPackage == ADD_ON_PACKAGE) {
            setreceivedpackage(ADD_ON_PACKAGE);
            setsearchCriteria({
              ...searchCriteria,
              packageTypeval: ADD_ON_PACKAGE,
            });
            setselectedPackage(ADD_ON_PACKAGE);
            setstoreSelectedPackage(ADD_ON_PACKAGE);
          } else if (selectedPackage !== '') {
            setselectedPackage(selectedPackage);
            setstoreSelectedPackage(selectedPackage);
          } else {
            setpackageCriteria(null);
            setselectedPackage('');
            setstoreSelectedPackage('');
          }
          setInternalContextProvider(response.data);
          setBucketCopy([...bucketCopy, gridData[index]]);
          if (!motorcycleIdentifiers.includes(departmentsEn)) {
            setNoOfInv(noOfInv + 1)
            setIsAnyItemAdded(true)
          }

          setIsMotorcycleAdded(motorcycleIdentifiers.includes(gridData[index]?.subDepartmentsEn));
          setcopyArrayData([...bucketCopy, gridData[index]]);

          console.log('copy', bucketCopy);
          console.log('tabledata.filter', gridData);
          const newTableData = gridData.filter((item, filterIndex) => {
            return filterIndex != index;
          });
          if (newTableData.length <= 0) {
            // setcontrolEmptyRecord(true);
            setresultController({
              ...resultControllerObj,
              controlEmptyRecord: true,
            });
          }
          // setsearchResultContext(newTableData);
          setsearchResult(newTableData);

          console.log('ItemMainAry', newTableData);
          setGridData(newTableData);
          setShowAddedItem(true);
        }
      } else if (response.status == 400) {
        // setpackageExceptionController(true);
        setmodalController({
          ...modalController,
          itemPricingFail: true,
        });
        if (response.data.errors[0].error == 'Invalid inventoryIds') {
          setPricexeptionMessage(
            t('No active price tags found for selected inventory')
          );
        } else {
          setPricexeptionMessage(response.data.errors[0].error);
        }
      }
    } else {
      setmodalController({
        ...modalController,
        reservedExceptionController: true,
      });
    }
  };






  const addController = (invNumber: any, status: any) => {
    if (
      salesLeadId !== null &&
      status === 'Reserved' &&
      storeSalesData !== undefined
    ) {
      let canCallPricing = false;
      for (let i = 0; i < storeSalesData.inventories.length; i++) {
        console.log('bvfdsd544', storeSalesData.inventories[i]);
        console.log('bgfdfd5651521541', invNumber);

        if (storeSalesData.inventories[i].inventoryNumber === invNumber) {
          canCallPricing = true;
          break;
        }
      }
      console.log('dsvcswcsd vc54257', canCallPricing);

      return canCallPricing;
    } else if (
      salesLeadId !== null &&
      status === 'Reserved' &&
      storeSalesData === undefined
    ) {
      return false;
    } else {
      return true;
    }
  };

  const pricePopulator = (response: any) => {
    let allowPopulatePrice = false;
    for (let i = 0; i < response.data.inventoryPriceInfo.length; i++) {
      if (response.data.inventoryPriceInfo[i].inventoryPrice.length > 1) {
        allowPopulatePrice = false;
        break;
      } else {
        allowPopulatePrice = true;
      }
    }

    if (allowPopulatePrice) {
      return allowPopulatePrice;
    } else {
      //const arrayCollection: any = [];
      const itemArrayCollection: any = [];
      for (let i = 0; i < response.data.inventoryPriceInfo.length; i++) {
        if (response.data.inventoryPriceInfo[i].inventoryPrice.length > 1) {
          // arrayCollection.push(
          //   response.priceTag[i].inventoryPriceTags[0],
          //   response.priceTag[i].inventoryPriceTags[1]
          // );
          settagBlueLabel({
            inventoryNumber:
              response.data.inventoryPriceInfo[i].inventoryNumber,
            inventoryDesc: response.data.inventoryPriceInfo[i].inventoryDesc,
            inventoryId: response.data.inventoryPriceInfo[i].inventoryId,
          });
          if (
            response.data.inventoryPriceInfo[i].inventoryPrice[0]
              .inventoryPriceType == 'ACTIVE'
          ) {
            setleftValue(response.data.inventoryPriceInfo[i].inventoryPrice[0]);
            setrightValue(
              response.data.inventoryPriceInfo[i].inventoryPrice[1]
            );
          } else {
            setleftValue(response.data.inventoryPriceInfo[i].inventoryPrice[1]);
            setrightValue(
              response.data.inventoryPriceInfo[i].inventoryPrice[0]
            );
          }
        } else {
          itemArrayCollection.push({
            inventoryId: Number(
              response.data.inventoryPriceInfo[i].inventoryId
            ),
            inventoryPriceId: Number(
              response.data.inventoryPriceInfo[i].inventoryPrice[0]
                .inventoryPriceId
            ),
          });
        }
      }
      setOpenPriceTag(true);
      setnewSingleInvPricingInvArray(itemArrayCollection); // this should be stored in a different array
    }
  };

  const pricingCallTrigger = async (packData: any) => {
    if (itemArray.length > 1) {
      // setmasterLoader(true);
      setLoaderBundle({ ...loaderBundle, masterLoader: true });

      // RP-668: packData only changes the package/discount classification for the SAME items
      // already in itemArray — no items are added or removed here, so legal/price's totalCost
      // ceiling is unchanged and does not need to be re-fetched. Only the rate can change under
      // the new package, so the Maximum Allowed Term is recomputed locally from the cached
      // legalTotalCost against the fresh rate returned by this pricingCall.
      const getResult = await pricingCall(//This one is for Package Item Search.(Data Not Setted to InternalContext)
        itemArray,
        null,
        false,
        priceController.AgrRateInp != '' && priceController.AgrRateInp != null
          ? parseFloat(priceController.AgrRateInp)
          : null,
        priceController.AgrTermInp != '' && priceController.AgrTermInp != null
          ? parseInt(priceController.AgrTermInp)
          : null,
        priceController.CompetitorCheck,
        packData,
        null
      );

      let computedMaximumAllowedTerm: number | undefined = maximumAllowedTerm;
      // Refresh item-price TRTO from successful package repricing, then retain the greater legal/item-price TRTO as the ceiling.
      const itemPriceTotalCost =
        getResult !== undefined && getResult.status == 200
          ? storeItemPriceTotalCost(getResult.data)
          : itemPriceTotalCostRef.current;
      const maximumAllowedTotalCost = deriveMaximumAllowedTotalCost(
        legalTotalCost,
        itemPriceTotalCost
      );
      if (
        getResult !== undefined &&
        getResult.status == 200 &&
        maximumAllowedTotalCost != null &&
        Number(getResult.data?.agreementPricing?.agreementRate)
      ) {
        computedMaximumAllowedTerm = deriveMaximumAllowedTerm(
          String(maximumAllowedTotalCost),
          getResult.data.agreementPricing.agreementRate,
          Number(getResult.data?.agreementPricing?.agreementTerm)
        );
        setMaximumAllowedTerm(computedMaximumAllowedTerm);
      }

      setLoaderBundle({ ...loaderBundle, masterLoader: false });
      if (getResult.data !== undefined && getResult.status == 200) {
        setaddedItem(getResult.data);
        console.log("correctagrrate", getResult?.data?.agreementPricing)
        if (getResult?.data?.agreementPricing) {
          setinitialAgrData(getResult?.data?.agreementPricing?.agreementRate)
          storeDefaultAgreementTerm(getResult.data); //Package-selection repricing flow
        }
        setInternalContextProvider(getResult.data);
        setmodalController({ ...modalController, addAllPopUp: false });
        if (
          getResult.data.packageInformation.packageTypeList !== null &&
          Object.keys(getResult.data.packageInformation.packageTypeList)
            .length !== 0 &&
          getResult.data.packageInformation.packageTypeList !== ''
        ) {
          if (packData == '') {
            setpackageCriteria(
              getResult.data.packageInformation.packageTypeList[0]
                .packageCriteria
            );
          } else {
            const filteredCriteria =
              getResult.data.packageInformation.packageTypeList.filter(
                (item, index) => {
                  if (packData == item.packageName) {
                    return item;
                  }
                }
              );
            setpackageCriteria(filteredCriteria[0].packageCriteria);
          }
          setreceivedpackage(getResult.data.itemPricing[0].packageName);
          setsearchCriteria({
            ...searchCriteria,
            packageTypeval: getResult.data.itemPricing[0].packageName,
          });
        } else if (packData == 'Add-On Package') {
          setreceivedpackage('Add-On Package');
          setpackageCriteria([]);
          setsearchCriteria({
            ...searchCriteria,
            packageTypeval: 'Add-On Package',
          });

        }
        setShowAddedItem(true);
        ContextSkeleton(
          getResult.data,
          itemArray,
          setTestInput,
          customerId,
          priceController,
          competitorDDValue,
          tireController
        );
        // Store latest agreementTotal from response as overriddenTotalCost
        if (featureFlagDetails?.EnableMaxTRTOBasedAgrOverride == '1') {
          const latestTotal = getResult.data.agreementPricing?.agreementTotal;
          if (latestTotal != null) {
            setpriceController(prev => ({
              ...prev,
              overriddenTotalCost: parseFloat(latestTotal)
            }));
          }
        }
      } else if (getResult.status == 400) {
        setLoaderBundle({ ...loaderBundle, masterLoader: false });
        setmodalController({
          ...modalController,
          itemPricingFail: true,
        });
        setPricexeptionMessage(getResult.data.errors[0].error);
      }

      return getResult;
    }
  };

  const closeRateTermPopUp = () => {
    // setinvalidTerm(false);
    setmodalController({ ...modalController, RateTermController: false });
    setpricingException('');
    calculateSetToDefault();
  };

  const closepackageExceptionController = () => {
    // setpackageExceptionController(false);
    setmodalController({
      ...modalController,
      packageExceptionController: false,
    });
  };

  const acceptPackageCriteria = () => {
    // setPackageExceptionPopup(false);
    setmodalController({ ...modalController, PackageExceptionPopup: false });
  };

  const closeAcceptPricingFail = () => {
    setmodalController({ ...modalController, itemPricingFail: false });
  };

  const clearbtnClick = (value: any) => {
    if (value === true) {
      setpackageDeptid([]);
      setpackageSubdepid([]);
      setpackageBracketid([]);
      // setpackageItemMasterid([]);
    }
  };

  const closeGroupPop = async () => {
    setmodalController({
      ...modalController,
      addAllPopUp: false,
      breakPopup: false,
    });
    const allowPricePopulate =
      isChoosePriceConfig == '1'
        ? await pricePopulator(PackagePricingResponse)
        : true;
    if (allowPricePopulate) {
      const getBreakPkgData: any = [];
      PackagePricingResponse.data.itemPricing.map((obj: any) => {
        if (obj.packagePriceId !== null && obj.packagePriceId !== 'null') {
          getBreakPkgData.push(Number(obj.packagePriceId));
        }
      });
      const uniqueBreakData = [...new Set(getBreakPkgData)];
      setbrokenPackageData(uniqueBreakData);
      setreceivedpackage('');
      setisCompCheck(false);
      setselectedCompetitor(undefined);
      setsearchCriteria({ ...searchCriteria, packageTypeval: '' });
      const newItemArray: any = [];

      // setpackageDataContext(PackagePricingResponse.packageInformation);
      //let pushingItemArrayId;

      console.log('PackagePricingResponse and itemarray', PackagePricingResponse, itemArray);
      if (PackagePricingResponse.data.itemPricing.length == 1) {
        setselectedPackage('');
        setstoreSelectedPackage('');
        PackagePricingResponse.data.itemPricing[0].packageName = '';
        PackagePricingResponse.data.itemPricing[0].packagePriceId = '';
      }
      else if (itemArray.length > 0) {
        console.log('containing multiple data');

        PackagePricingResponse.data.itemPricing.map(
          (packageMap: any, indexPak: any) => {
            console.log(
              'mapper of parseInt(packageMap.inventoryId)',
              parseInt(packageMap.inventoryId)
            );

            console.log('times reached here jhbvd');
            newItemArray.push({
              inventoryId: Number(packageMap.inventoryId),
              inventoryPriceId: Number(packageMap.inventoryPriceId),
            });
          }
        );
      }
      if (itemArray.length == 0) {
        console.log('reached singlr map');
        newItemArray.push({
          inventoryId: Number(
            PackagePricingResponse.data.itemPricing[
              PackagePricingResponse.data.itemPricing.length - 1
            ].inventoryId
          ),
          inventoryPriceId: Number(
            PackagePricingResponse.data.itemPricing[
              PackagePricingResponse.data.itemPricing.length - 1
            ].inventoryPriceId
          ),
        });
      }
      if (newItemArray.length > 1) {
        setpackageListData(
          PackagePricingResponse.data.packageInformation.packageTypeList
        );
        setreceivedpackage(
          PackagePricingResponse.data.itemPricing[0].packageName
        );
        if (selectedPackage == '') {
          setpackageCriteria(
            PackagePricingResponse.data.packageInformation.packageTypeList[0]
              .packageCriteria
          );
        } else {
          const filteredCriteria =
            PackagePricingResponse.data.packageInformation.packageTypeList.filter(
              (item, index) => {
                if (selectedPackage == item.packageName) {
                  return item;
                }
              }
            );
          setpackageCriteria(filteredCriteria[0].packageCriteria);
        }
        setsearchCriteria({
          ...searchCriteria,
          packageTypeval:
            PackagePricingResponse.data.itemPricing[0].packageName,
        });
      }

      setItemArray(newItemArray);
      setitemArrayData(newItemArray);
      setIsPackage(false);
      console.log('Break Item Array', newItemArray);
      console.log('itemArray in closeGroupPop', itemArray);

      console.log(
        'PackagePricingResponse.itemPricing.inventoryId',
        PackagePricingResponse.data.itemPricing[0].inventoryId
      );

      setfooterControlData(false);

      let tireController = false;
      const responseHolder = PackagePricingResponse.data.itemPricing;
      for (let i = 0; i < responseHolder.length; i++) {
        if (
          responseHolder[i].rmsItemNumber == '200012120' ||
          responseHolder[i].rmsItemNumber == '200012121' ||
          responseHolder[i].rmsItemNumber == '200013177' ||
          responseHolder[i].rmsItemNumber == '200012118' ||
          responseHolder[i].rmsItemNumber == '200013350' ||
          responseHolder[i].rmsItemNumber == '200012119'
        ) {
          tireController = true;
          // settireController(true);
          break;
        }
      }
      ContextSkeleton(
        PackagePricingResponse.data,
        newItemArray,
        setTestInput,
        customerId,
        priceController,
        competitorDDValue,
        tireController
      );

      setInternalContextProvider(PackagePricingResponse.data);
      setaddedItem(PackagePricingResponse.data);
      setBucketCopy([...bucketCopy, gridData[collectIndex]]);
      setcopyArrayData([...bucketCopy, gridData[collectIndex]]);
      console.log('copy', bucketCopy);
      console.log('received PackageItemId', PackageItemId);
      const newTableData = gridData.filter((item) => {
        if (parseInt(item.inventoryId) == PackageItemId) {
          console.log('PackageItemId in logic added', PackageItemId);
          console.log('item.inventoryid in logic added', item.inventoryid);
          console.log('Logic Worked');
        }
        console.log('filter item', item);
        return parseInt(item.inventoryId) != PackageItemId;
      });
      if (newTableData.length <= 0) {
        setresultController({
          ...resultControllerObj,
          controlEmptyRecord: true,
        });
      }
      console.log('Add Package newTableData', newTableData);
      setGridData(newTableData);
      setShowAddedItem(true);
    }
  };
  // this method is used to close the group popup //PS-12
  const declineAddOther = () => {
    setmodalController({
      ...modalController,
      addAllPopUp: false,
      breakPopup: true,
    });
  };

  const deleteSingleItem = async (itemId: any) => {
    setLoaderBundle({ ...loaderBundle, masterLoader: true });

    console.log('Required Item Id', itemId);
    setdeleteId({ ...deleteId, invDeleteId: itemId });
  };

  // Role hierarchy for comparing SLA roles (higher index = higher role)
  const roleHierarchy = [
    'FSC-CAR', 'CAR', 'RPMT', 'FSC-AM', 'AM', 'FSC-LAM', 'LAM',
    'FSC-SMT', 'SMT', 'FSC-SM', 'SM', 'FSC-SSM', 'SSM', 'CAM',
    'FSC-DMT', 'DMT', 'FSC-DM', 'DM', 'FSC-RDT', 'RDT', 'FSC-RD', 'RD'
  ];

  // Helper function to check if newRole is higher than currentRole
  const isHigherRole = (newRole: string, currentRole: string | null): boolean => {
    if (!currentRole) return true;
    const newIndex = roleHierarchy.indexOf(newRole);
    const currentIndex = roleHierarchy.indexOf(currentRole);
    return newIndex > currentIndex;
  };

  const receiveAgreementRate = (value: any, approvedRole?: string) => {
    // Update the SLA role ref if:
    // 1. It's not already set (first SLA approval), OR
    // 2. The new role is higher than the current one (escalation)
    // This ensures the highest approved role is preserved until "Set to Default" is clicked
    if (approvedRole !== undefined && (slaApprovedRoleRef.current === null || isHigherRole(approvedRole, slaApprovedRoleRef.current))) {
      slaApprovedRoleRef.current = approvedRole;
    }
    // Preserve the current term override so changing the rate in the UI does not clear the user's term selection.
    setpriceController((previous: any) => ({
      ...previous,
      AgrRateInp: value
    }));
  };
  const receiveAgreementTerm = (value: any, approvedRole?: string) => {
    // Update the SLA role ref if:
    // 1. It's not already set (first SLA approval), OR
    // 2. The new role is higher than the current one (escalation)
    // This ensures the highest approved role is preserved until "Set to Default" is clicked
    if (approvedRole !== undefined && (slaApprovedRoleRef.current === null || isHigherRole(approvedRole, slaApprovedRoleRef.current))) {
      slaApprovedRoleRef.current = approvedRole;
    }
    // Preserve the current rate override so changing the term in the UI does not clear the user's rate selection.
    setpriceController((previous: any) => ({
      ...previous,
      AgrTermInp: value
    }));
  };

  const calculateSetToDefault = () => {
    setpriceController({
      ...priceController,
      AgrRateInp: null,
      AgrTermInp: null,
      CompetitorCheck: false
    });
    setTermOverrideLimitBase(
      initialAgrTerm !== null && initialAgrTerm !== undefined
        ? Number(initialAgrTerm)
        : undefined
    );
    // Clear the SLA approved role ref when resetting to default
    slaApprovedRoleRef.current = null;
    setcheckedState(false);
  };
  const receiveCompetitor = (value: any) => {
    setpriceController({ ...priceController, CompetitorCheck: value });
  };

  const receiveCompetitorDDValue = (value: any) => {
    console.log('value of the choosen competitor', value);

    if (value == undefined || value == null) {
      console.log('reached the if part');
      setcompetitorDDValue(null);
    } else {
      console.log('reached the else part');
      setcompetitorDDValue(value);
    }

    ContextSkeleton(
      addedItem,
      itemArray,
      setTestInput,
      customerId,
      priceController,
      value,
      TestInput.TireAgreementFlow
    );
  };

  const storeSelectedPackage = (value) => {
    console.log('value of the selected packjage', value);

    setselectedPackage(value);
    setstoreSelectedPackage(value);
  };

  const closeReserved = () => {
    setmodalController({
      ...modalController,
      reservedExceptionController: false,
    });
  };

  useEffect(() => {
    console.log('change of all selectedPackage', selectedPackage);
  }, [selectedPackage]);

  const methodAssigner: any = {
    closeGroupPopCaller: closeGroupPop,
    acceptBreakPackageCaller: acceptBreakPackage,
    declineBreakPackageCaller: declineBreakPackage,
    closepackageExceptionControllerCaller: closepackageExceptionController,
    addAllItemCaller: addAllItem,
    closeRateTermPopUpCaller: closeRateTermPopUp,
    declineAddOtherCaller: declineAddOther,
    declineAddingCaller: declineAdding,
    acceptPackageCriteriaCaller: acceptPackageCriteria,
    closeModalCaller: closeModal,
    acceptPricingFailCaller: closeAcceptPricingFail,
    closeReservedPopup: closeReserved,
  };

  const tagSingleInvCaller = async (selectedTag?: any) => {
    setLoaderBundle({ ...loaderBundle, masterLoader: true });

    console.log('vfdsdd cvfd', newSingleInvPricingInvArray);

    let arrayForm: any;
    if (selectedTag === undefined) {
      arrayForm = newSingleInvPricingInvArray;
    } else {
      arrayForm = [...itemArray, selectedTag];
    }
    let packageParameter = '';
    if (arrayForm.length > 0 || selectedPackage == ADD_ON_PACKAGE) {
      packageParameter = selectedPackage;
    }
    console.log('fds wedfd 65454', arrayForm);
    console.log('vfdsx sdcvfd777', selectedTag);
    const { response } = await pricingCallWithLegalPrice(//This one is for single inventory price tag flow
      arrayForm,
      null,
      false,
      null,
      null,
      false,
      packageParameter,
      null
    );
    setLoaderBundle({ ...loaderBundle, masterLoader: false });
    if (response.status === 200) {
      setisCompCheck(false);
      setselectedCompetitor(undefined);
      const getBreakPkgData: any = [];
      response.data.itemPricing.map((obj: any) => {
        if (obj.packagePriceId !== null && obj.packagePriceId !== 'null') {
          getBreakPkgData.push(Number(obj.packagePriceId));
        }
      });
      const uniqueBreakData = [...new Set(getBreakPkgData)];
      setbrokenPackageData(uniqueBreakData);
      const collectPriceArray: any = [];

      response.data.itemPricing.map((obj, index) => {
        collectPriceArray.push({
          inventoryId: Number(obj.inventoryId),
          inventoryPriceId: Number(obj.inventoryPriceId),
        });
      });
      setItemArray(collectPriceArray);
      setitemArrayData(collectPriceArray);
      let tireController: any = false;
      const responseHolder = response.data.itemPricing;
      for (let i = 0; i < responseHolder.length; i++) {
        if (
          responseHolder[i].rmsItemNumber == '200012120' ||
          responseHolder[i].rmsItemNumber == '200012121' ||
          responseHolder[i].rmsItemNumber == '200013177' ||
          responseHolder[i].rmsItemNumber == '200012118' ||
          responseHolder[i].rmsItemNumber == '200013350' ||
          responseHolder[i].rmsItemNumber == '200012119'
        ) {
          tireController = true;
          settireController(true);
          break;
        }
      }
      setinitialAgrData(response?.data?.agreementPricing?.agreementRate);
      storeDefaultAgreementTerm(response.data); //Single-inventory price-tag flow

      ContextSkeleton(
        response.data,
        arrayForm,
        setTestInput,
        customerId,
        priceController,
        competitorDDValue,
        tireController
      );
      setIsPackage(false);
      setpackageListData(response.data.packageInformation.packageTypeList);
      setfooterControlData(false);
      if (isPackage) {
        console.log('reached expected');
        console.log('reached expected copy', bucketCopy);
        const copyTableData = gridData;
        bucketCopy.map((obj: any) => {
          copyTableData.push(obj);
        });
        setGridData(copyTableData);
      }

      if (
        response.data.packageInformation.packageTypeList !== null &&
        Object.keys(response.data.packageInformation.packageTypeList).length !==
        0 &&
        response.data.packageInformation.packageTypeList !== ''
      ) {
        if (packageParameter == '') {
          setpackageCriteria(
            response.data.packageInformation.packageTypeList[0].packageCriteria
          );
        } else {
          const filteredCriteria =
            response.data.packageInformation.packageTypeList.filter(
              (item, index) => {
                if (packageParameter == item.packageName) {
                  return item;
                }
              }
            );
          setpackageCriteria(filteredCriteria[0].packageCriteria);
        }
        setreceivedpackage(response.data.itemPricing[0].packageName);
        setsearchCriteria({
          ...searchCriteria,
          packageTypeval: response.data.itemPricing[0].packageName,
        });
        setselectedPackage(response.data.itemPricing[0].packageName);
        setstoreSelectedPackage(response.data.itemPricing[0].packageName);
      }
      else if (selectedPackage == ADD_ON_PACKAGE) {
        setreceivedpackage(ADD_ON_PACKAGE);
        setsearchCriteria({
          ...searchCriteria,
          packageTypeval: ADD_ON_PACKAGE,
        });
        setselectedPackage(ADD_ON_PACKAGE);
        setstoreSelectedPackage(ADD_ON_PACKAGE);

      }
      else if (selectedPackage !== '') {
        setselectedPackage(selectedPackage);
        setstoreSelectedPackage(selectedPackage);
      } else {
        setpackageCriteria(null);
        setselectedPackage('');
        setstoreSelectedPackage('');
      }
      setInternalContextProvider(response.data);
      if (true) {
        setNoOfInv(noOfInv + 1)
        setIsAnyItemAdded(true)
      }

      setBucketCopy([...bucketCopy, gridData[collectIndex]]);
      setcopyArrayData([...bucketCopy, gridData[collectIndex]]);
      const newTableData = gridData.filter((item, filterIndex) => {
        return filterIndex != collectIndex;
      });
      if (newTableData.length <= 0) {
        // setcontrolEmptyRecord(true);
        setresultController({
          ...resultControllerObj,
          controlEmptyRecord: true,
        });
      }

      setsearchResult(newTableData);

      console.log('ItemMainAry', newTableData);
      setGridData(newTableData);

      setShowAddedItem(true);
    }
  };

  const tagPackageInvCaller = async (decider) => {
    setopenPackagePriceTag(false);
    setLoaderBundle({ ...loaderBundle, masterLoader: true });
    // RP-668 (sequential path): this package's item list is resolved server-side via
    // PackageItemId and is unknown until this pricingCall response arrives, so legal/price
    // cannot fire in parallel here. It is fired in the background (no loader) right after —
    // see fetchLegalPriceAsync — instead of being awaited before the loader hides.
    const response = await pricingCall(//This one is for package inv price tag flow
      [],
      PackageItemId,
      true,
      null,
      null,
      false,
      '',
      decider
    );
    setLoaderBundle({ ...loaderBundle, masterLoader: false });

    if (
      response !== undefined &&
      response.status == 200 &&
      featureFlagDetails?.EnableMaxTRTOBasedAgrOverride == '1'
    ) {
      const itemPriceTotalCost = storeItemPriceTotalCost(response.data);
      // Increment once per legal-price request so stale responses can be ignored.
      const legalPriceCallTrackerCount = ++legalPriceCallTrackerRef.current;
      const itemsForLegalPrice = (response.data?.itemPricing || []).map((item: any) => ({
        inventoryId: item.inventoryId,
        inventoryPriceId: item.inventoryPriceId,
      }));
      // Fire-and-forget: not awaited, so the loader above does not wait for this.
      // Same sequential pattern as addAllItem: pricing returns first, legal-price resolves later.
      fetchLegalPriceAsync(
        itemsForLegalPrice,
        response.data?.agreementPricing?.agreementRate,
        response.data?.agreementPricing?.agreementTerm,
        itemPriceTotalCost,
        legalPriceCallTrackerCount
      );
    }
    if (response.status == 200) {
      setisPackageFlow(false);
      setbrokenPackageData([]);
      setisCompCheck(false);
      setselectedPackagePriceTag(decider);
      setStoreSelectedPackagePriceTag(decider);
      setselectedCompetitor(undefined);
      setIsPackage(true);
      setpackageListData(response.data.packageInformation.packageTypeList);
      setinitialAgrData(response.data.agreementPricing.agreementRate);
      storeDefaultAgreementTerm(response.data); // Package price-tag flow

      setreceivedpackage(response.data.itemPricing[0].packageName);
      // Keep the selected package available to pricing requests after Next/Previous navigation.
      setselectedPackage(response.data.itemPricing[0].packageName);
      setstoreSelectedPackage(response.data.itemPricing[0].packageName);
      setsearchCriteria({
        ...searchCriteria,
        packageTypeval: response.data.itemPricing[0].packageName,
      });
      let newItemArray: any = [];
      if (response.data !== undefined) {
        response.data.itemPricing.map((value: any) => {
          console.log('individual inv id of package', value.inventoryId);

          newItemArray = [
            ...newItemArray,
            {
              inventoryId: Number(value.inventoryId),
              inventoryPriceId: Number(value.inventoryPriceId),
            },
          ];
        });

        setfooterControlData(false);

        if (
          response.data.packageInformation.packageTypeList !== null &&
          Object.keys(response.data.packageInformation.packageTypeList)
            .length !== 0 &&
          response.data.packageInformation.packageTypeList !== ''
        ) {
          setpackageCriteria(
            response.data.packageInformation.packageTypeList[0].packageCriteria
          );
          setreceivedpackage(response.data.itemPricing[0].packageName);
          setsearchCriteria({
            ...searchCriteria,
            packageTypeval: response.data.itemPricing[0].packageName,
          });
        } else {
          setpackageCriteria(null);
        }
      }
      setItemArray(newItemArray);
      // setitemArrayContext(newItemArray);
      setitemArrayData(newItemArray);
      let tireController = false;
      const responseHolder = response.data.itemPricing;
      for (let i = 0; i < responseHolder.length; i++) {
        if (
          responseHolder[i].rmsItemNumber == '200012120' ||
          responseHolder[i].rmsItemNumber == '200012121' ||
          responseHolder[i].rmsItemNumber == '200013177' ||
          responseHolder[i].rmsItemNumber == '200012118' ||
          responseHolder[i].rmsItemNumber == '200013350' ||
          responseHolder[i].rmsItemNumber == '200012119'
        ) {
          tireController = true;
          settireController(true);
          break;
        }
      }
      ContextSkeleton(
        response.data,
        newItemArray,
        setTestInput,
        customerId,
        priceController,
        competitorDDValue,
        tireController
      );

      setInternalContextProvider(response.data);

      // setGridData([...tabledata, copy]);
      const copyTableData = gridData;

      // setGridData([...tabledata, obj]);
      bucketCopy.map((obj: any) => {
        copyTableData.push(obj);
      });
      setGridData(copyTableData);
      // setcopy([]);

      let emptyCopy: any = [];
      if (response.data !== undefined) {
        response.data.itemPricing.map((obj: any) => {
          gridData.map((value: any) => {
            if (value.inventoryId === obj.inventoryId) {
              emptyCopy = [...emptyCopy, value];
            }
          });
        });
        setBucketCopy(emptyCopy);
        // setcopyArrayContext(emptyCopy);
        setcopyArrayData(emptyCopy);
      }
      console.log('the empty copy is', emptyCopy);
      console.log('before tab data values', gridData);
      let emptyTableData: any = [];
      emptyTableData = gridData.filter((object) => !emptyCopy.includes(object));
      console.log('exptyTableData', emptyTableData);
      setGridData(emptyTableData);
      if (response.data !== undefined) {
        // setaddedItemContext(response.data);
        setaddedItem(response.data);

        setShowAddedItem(true);
        // setaddAllPopUp(false);
        setmodalController({ ...modalController, addAllPopUp: false });
      }
    } else if (response.status == 400) {
      // setpackageExceptionController(true);
      setmodalController({
        ...modalController,
        itemPricingFail: true,
      });
      setPricexeptionMessage(response.data.errors[0].error);
      // setmasterLoader(false);
      setLoaderBundle({ ...loaderBundle, masterLoader: false });
    }
  };

  const SLACancel = () => {
    setSLAController({ ...SLAController, TwoFactorCancelClick: false });
    setSecondFactorEnabled(false);
  };

  const closeSLA = () => {
    setSLAController({ ...SLAController, TwoFactorCancelClick: false });
    setSecondFactorEnabled(false);
    if (isPackageFlow) {
      setopenPackagePriceTag(true);
    } else {
      setOpenPriceTag(true);
    }
  };

  const SLACompleted = (value: any) => {
    setSecondFactorEnabled(false);
    if (isPackageFlow) {
      tagPackageInvCaller('PRTD');
    } else {
      tagSingleInvCaller();
    }
  };

  const triggerNextModal = (inventoryId, inventoryPriceId, decider) => {
    console.log('sdfbvfdfv inventoryId sd', inventoryId);
    console.log('sdfdedcx inventoryPriceId bvc', inventoryPriceId);

    setnewSingleInvPricingInvArray([
      ...newSingleInvPricingInvArray,
      {
        inventoryId: Number(inventoryId),
        inventoryPriceId: Number(inventoryPriceId),
      },
    ]);

    // setnewSingleInvPricingInvArray({
    //   inventoryId: Number(inventoryId),
    //   inventoryPriceId: Number(inventoryPriceId),
    // });
    setOpenPriceTag(false);
    if (decider === 'Printed') {
      setSecondFactorEnabled(true);
    } else if (decider === 'Active') {
      tagSingleInvCaller({
        inventoryId: Number(inventoryId),
        inventoryPriceId: Number(inventoryPriceId),
      });
    }
  };

  const triggerPackageNextModal = (decider: any) => {
    console.log('ASDCVD decider sd', decider);

    setopenPackagePriceTag(false);
    if (decider === 'PRTD') {
      setSecondFactorEnabled(true);
    }
  };

  const truncString = (str: any, max: number, add: any) => {
    add = add || '...';
    return typeof str === 'string' && str.length > max
      ? str.substring(0, max) + add
      : str;
  };

  const openPriceModal = () => {
    return (
      <Grid className="">
        <Card
          className={`${classes.racSkyBlue} ${classes.bluecards} `}
          style={{ padding: '10px 10px', backgroundColor: '#EFF4FF' }}
        >
          <Typography
            style={{
              float: 'left',
              marginRight: '48px',
              color: '#2279fd',
              fontSize: '14px',
              fontFamily: 'opensans-bold',
            }}
          >
            {t("Inventory #")} : {tagBlueLabel.inventoryNumber}
          </Typography>
          <Typography
            style={{
              float: 'left',
              color: '#2279fd',
              fontSize: '14px',
              fontFamily: 'opensans-bold',
            }}
            title={
              tagBlueLabel?.inventoryDesc?.length > 22
                ? tagBlueLabel?.inventoryDesc
                : ''
            }
          >
            {t("Description")} : {truncString(tagBlueLabel.inventoryDesc, 22, '...')}
          </Typography>
        </Card>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography
              className={classes.margincard}
              style={{ fontFamily: 'OpenSans-bold', fontSize: '15px' }}
            >
              {t("New Price Tag (Active Pricing)")}
            </Typography>
            <Grid
              md={12}
              style={{ display: 'flex', flexWrap: 'wrap' }}
              className={classes.margincard}
            >
              <Typography
                style={{ color: '#4A5174', fontFamily: 'OpenSans-bold' }}
              >
                {t("Weekly Rate")}:
              </Typography>
              <Typography
                style={{
                  fontFamily: 'OpenSans-bold',
                  fontSize: '14px',
                  float: 'right',
                  paddingLeft: '13px',
                }}
              >
                ${leftValue.tagRate}
              </Typography>
            </Grid>
            <Grid
              md={12}
              style={{ display: 'flex', flexWrap: 'wrap' }}
              className={classes.margincard}
            >
              <Typography
                style={{ color: '#4A5174', fontFamily: 'OpenSans-bold' }}
              >
                {t("Weekly Term")}:
              </Typography>
              <Typography
                style={{
                  fontFamily: 'OpenSans-bold',
                  fontSize: '14px',
                  float: 'right',
                  paddingLeft: '10px',
                }}
              >
                {leftValue.tagTerm}
              </Typography>
            </Grid>
            {featureFlagDetails.AddOnPricing == '1' ? <Grid
              md={12}
              style={{ display: 'flex', flexWrap: 'wrap' }}
              className={classes.margincard}
            >
              <Typography
                style={{ color: '#4A5174', fontFamily: 'OpenSans-bold' }}
              >
                {t("Add-On Rate")}:
              </Typography>
              <Typography
                style={{
                  fontFamily: 'OpenSans-bold',
                  fontSize: '14px',
                  float: 'right',
                  paddingLeft: '10px',
                }}
              >
                {leftValue.tagAddOnRate ? `$${leftValue.tagAddOnRate}` : '-'}
              </Typography>
            </Grid> : null}
            <Grid
              md={12}
              style={{ display: 'flex', flexWrap: 'wrap' }}
              className={classes.margincard}
            >
              <Typography
                style={{ color: '#4A5174', fontFamily: 'OpenSans-bold' }}
              >
                {t("Cash Price")}:
              </Typography>
              <Typography
                style={{
                  fontFamily: 'OpenSans-bold',
                  fontSize: '14px',
                  float: 'right',
                  paddingLeft: '27px',
                }}
              >
                ${leftValue.cashPrice}
              </Typography>
            </Grid>
            <Grid
              md={12}
              style={{ display: 'flex', flexWrap: 'wrap' }}
              className={classes.margincard}
            >
              <Typography
                style={{ color: '#4A5174', fontFamily: 'OpenSans-bold' }}
              >
                {t("Total Cost")}:
              </Typography>
              <Typography
                style={{
                  fontFamily: 'OpenSans-bold',
                  fontSize: '14px',
                  float: 'right',
                  paddingLeft: '30px',
                }}
              >
                ${leftValue.tagTotal}
              </Typography>
            </Grid>
            <Grid className={`${classes.py4} ${classes.textCenter}`}>
              <RACButton
                className={classes.mxe}
                variant="contained"
                color="primary"
                onClick={() =>
                  triggerNextModal(
                    tagBlueLabel.inventoryId,
                    leftValue.inventoryPriceId,
                    'Active'
                  )
                }
              >
                {t("ADD")}
              </RACButton>
            </Grid>
          </Grid>
          <Divider
            orientation="vertical"
            style={{
              position: 'absolute',
              height: '200px',
              right: '320px',
              top: '140px',
              marginTop: '15px',
            }}
          ></Divider>
          {/* <hr style={{backgroundColor:"red",transform: 'rotate(90deg)',margin:'inherit'}}></hr> */}
          <Grid item xs={6}>
            <Typography
              className={classes.margincard}
              style={{ fontFamily: 'OpenSans-bold', fontSize: '15px' }}
            >
              {t("Printed Price Tag")}
            </Typography>
            <Grid
              md={12}
              style={{ display: 'flex', flexWrap: 'wrap' }}
              className={classes.margincard}
            >
              <Typography
                style={{ color: '#4A5174', fontFamily: 'OpenSans-bold' }}
              >
                {t("Weekly Rate")}:
              </Typography>
              <Typography
                style={{
                  fontFamily: 'OpenSans-bold',
                  fontSize: '14px',
                  float: 'right',
                  paddingLeft: '13px',
                }}
              >
                ${rightValue.tagRate}
              </Typography>
            </Grid>
            <Grid
              md={12}
              style={{ display: 'flex', flexWrap: 'wrap' }}
              className={classes.margincard}
            >
              <Typography
                style={{ color: '#4A5174', fontFamily: 'OpenSans-bold' }}
              >
                {t("Weekly Term")}:
              </Typography>
              <Typography
                style={{
                  fontFamily: 'OpenSans-bold',
                  fontSize: '14px',
                  float: 'right',
                  paddingLeft: '10px',
                }}
              >
                {rightValue.tagTerm}
              </Typography>
            </Grid>
            {featureFlagDetails.AddOnPricing == '1' ? <Grid
              md={12}
              style={{ display: 'flex', flexWrap: 'wrap' }}
              className={classes.margincard}
            >
              <Typography
                style={{ color: '#4A5174', fontFamily: 'OpenSans-bold' }}
              >
                {t("Add-On Rate")}:
              </Typography>
              <Typography
                style={{
                  fontFamily: 'OpenSans-bold',
                  fontSize: '14px',
                  float: 'right',
                  paddingLeft: '10px',
                }}
              >
                {rightValue.tagAddOnRate ? `$${rightValue.tagAddOnRate}` : '-'}
              </Typography>
            </Grid> : null}
            <Grid
              md={12}
              style={{ display: 'flex', flexWrap: 'wrap' }}
              className={classes.margincard}
            >
              <Typography
                style={{ color: '#4A5174', fontFamily: 'OpenSans-bold' }}
              >
                {t("Cash Price")}:
              </Typography>
              <Typography
                style={{
                  fontFamily: 'OpenSans-bold',
                  fontSize: '14px',
                  float: 'right',
                  paddingLeft: '27px',
                }}
              >
                ${rightValue.cashPrice}
              </Typography>
            </Grid>
            <Grid
              md={12}
              style={{ display: 'flex', flexWrap: 'wrap' }}
              className={classes.margincard}
            >
              <Typography
                style={{ color: '#4A5174', fontFamily: 'OpenSans-bold' }}
              >
                {t("Total Cost")}:
              </Typography>
              <Typography
                style={{
                  fontFamily: 'OpenSans-bold',
                  fontSize: '14px',
                  float: 'right',
                  paddingLeft: '30px',
                }}
              >
                ${rightValue.tagTotal}
              </Typography>
            </Grid>
            <Grid className={`${classes.py4} ${classes.textCenter}`}>
              <RACButton
                className={classes.mxe}
                variant="contained"
                color="primary"
                onClick={() =>
                  triggerNextModal(
                    tagBlueLabel.inventoryId,
                    rightValue.inventoryPriceId,
                    'Printed'
                  )
                }
              >
                {t("ADD")}
              </RACButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const dynamicInvNumberBinding = () => {
    console.log('dfdc 8555 packageInvPopulator', packageInvPopulator);

    return packageInvPopulator.map((obj: any, index: any) => {
      return (
        <Typography
          key={index}
          variant="caption"
          className={`${agrInfoClassName.priceTagLabelColour} ${classes.width100} ${classes.floatLeft} ${classes.margincardsize}`}
        >
          {obj.inventoryNumber}
        </Typography>
      );
    });
  };

  const dynamicInvDescriptionBinding = () => {
    return packageInvPopulator.map((obj: any, index: any) => {
      return (
        <Typography
          key={index}
          variant="caption"
          className={`${agrInfoClassName.priceTagLabelColour} ${classes.width100} ${classes.floatLeft} ${classes.margincardsize}`}
        >
          {obj.inventoryName}
        </Typography>
      );
    });
  };

  const openPackagePriceModal = () => {
    return (
      <Grid className="">
        <Card
          className={`${classes.racSkyBlue} ${classes.bluecards} `}
          style={{ padding: '10px 10px', backgroundColor: '#EFF4FF' }}
        >
          <Typography
            style={{
              float: 'left',
              color: '#2279fd',
              fontSize: '14px',
              fontFamily: 'opensans-bold',
            }}
            title={
              leftValue?.inventoryName?.length > 22
                ? leftValue?.inventoryName
                : ''
            }
          >
            {t("Package Type")} : {packageBlueLabel}
          </Typography>
        </Card>
        <Card
          className={`${classes.racSkyBlue} ${classes.bluecards} ${classes.mt3}`}
          style={{
            padding: '10px 10px',
            backgroundColor: '#EFF4FF',
            maxHeight: '130px',
            overflow: 'auto',
          }}
        >
          <Grid className={`${classes.floatLeft}`} md={4}>
            <Typography
              variant="caption"
              style={{
                float: 'left',
                color: '#2279fd',
                fontSize: '15px',
                fontFamily: 'opensans-bold',
                width: '100%',
                backgroundColor: '#EFF4FF',
                zIndex: '1',
                top: '-10px',
                position: 'sticky',
              }}
            >
              {t("Inventory #")} :{' '}
            </Typography>
            {dynamicInvNumberBinding()}
          </Grid>

          <Grid className={`${classes.floatLeft}`} md={8}>
            <Typography
              variant="caption"
              style={{
                float: 'left',
                color: '#2279fd',
                fontSize: '15px',
                fontFamily: 'opensans-bold',
                width: '100%',
                backgroundColor: '#EFF4FF',
                zIndex: '1',
                top: '-10px',
                position: 'sticky',
              }}
            //className={`${agrInfoClassName.agrGenaralInfoColourLabel} ${classes.width100} ${classes.floatLeft}`}
            >
              {t("Description")} :{' '}
            </Typography>
            {dynamicInvDescriptionBinding()}
          </Grid>
        </Card>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography
              className={classes.margincard}
              style={{ fontFamily: 'OpenSans-bold', fontSize: '15px' }}
            >
              {t("New Price Tag (Active Pricing)")}
            </Typography>
            <Grid
              md={12}
              style={{ display: 'flex', flexWrap: 'wrap' }}
              className={classes.margincard}
            >
              <Typography
                style={{ color: '#4A5174', fontFamily: 'OpenSans-bold' }}
              >
                {t("Agreement Rate")}:
              </Typography>
              <Typography
                style={{
                  fontFamily: 'OpenSans-bold',
                  fontSize: '14px',
                  float: 'right',
                  paddingLeft: '27px',
                }}
              >
                ${PackageleftValue.agreementRate}
              </Typography>
            </Grid>
            <Grid
              md={12}
              style={{ display: 'flex', flexWrap: 'wrap' }}
              className={classes.margincard}
            >
              <Typography
                style={{ color: '#4A5174', fontFamily: 'OpenSans-bold' }}
              >
                {t("Agreement Term")}:
              </Typography>
              <Typography
                style={{
                  fontFamily: 'OpenSans-bold',
                  fontSize: '14px',
                  float: 'right',
                  paddingLeft: '27px',
                }}
              >
                {PackageleftValue.agreementTerm}
              </Typography>
            </Grid>
            <Grid
              md={12}
              style={{ display: 'flex', flexWrap: 'wrap' }}
              className={classes.margincard}
            >
              <Typography
                style={{ color: '#4A5174', fontFamily: 'OpenSans-bold' }}
              >
                {t("Cash Price")}:
              </Typography>
              <Typography
                style={{
                  fontFamily: 'OpenSans-bold',
                  fontSize: '14px',
                  float: 'right',
                  paddingLeft: '70px',
                }}
              >
                ${PackageleftValue.cashPrice}
              </Typography>
            </Grid>
            <Grid
              md={12}
              style={{ display: 'flex', flexWrap: 'wrap' }}
              className={classes.margincard}
            >
              <Typography
                style={{ color: '#4A5174', fontFamily: 'OpenSans-bold' }}
              >
                {t("Total Cost")}:
              </Typography>
              <Typography
                style={{
                  fontFamily: 'OpenSans-bold',
                  fontSize: '14px',
                  float: 'right',
                  paddingLeft: '70px',
                }}
              >
                ${PackageleftValue.totalCost}
              </Typography>
            </Grid>
            <Grid className={`${classes.py4} ${classes.textCenter}`}>
              <RACButton
                className={classes.mxe}
                variant="contained"
                color="primary"
                onClick={() => tagPackageInvCaller('ACTIVE')}
              >
                {t("ADD")}
              </RACButton>
            </Grid>
          </Grid>
          <Divider
            orientation="vertical"
            style={{
              position: 'absolute',
              height: '200px',
              right: '320px',
              top: '140px',
              marginTop: '15px',
            }}
          ></Divider>
          {/* <hr style={{backgroundColor:"red",transform: 'rotate(90deg)',margin:'inherit'}}></hr> */}
          <Grid item xs={6}>
            <Typography
              className={classes.margincard}
              style={{ fontFamily: 'OpenSans-bold', fontSize: '15px' }}
            >
              {t("Printed Price Tag")}
            </Typography>
            <Grid
              md={12}
              style={{ display: 'flex', flexWrap: 'wrap' }}
              className={classes.margincard}
            >
              <Typography
                style={{ color: '#4A5174', fontFamily: 'OpenSans-bold' }}
              >
                {t("Agreement Rate")}:
              </Typography>
              <Typography
                style={{
                  fontFamily: 'OpenSans-bold',
                  fontSize: '14px',
                  float: 'right',
                  paddingLeft: '27px',
                }}
              >
                ${PackagerightValue.agreementRate}
              </Typography>
            </Grid>
            <Grid
              md={12}
              style={{ display: 'flex', flexWrap: 'wrap' }}
              className={classes.margincard}
            >
              <Typography
                style={{ color: '#4A5174', fontFamily: 'OpenSans-bold' }}
              >
                {t("Agreement Term")}:
              </Typography>
              <Typography
                style={{
                  fontFamily: 'OpenSans-bold',
                  fontSize: '14px',
                  float: 'right',
                  paddingLeft: '27px',
                }}
              >
                {PackagerightValue.agreementTerm}
              </Typography>
            </Grid>
            <Grid
              md={12}
              style={{ display: 'flex', flexWrap: 'wrap' }}
              className={classes.margincard}
            >
              <Typography
                style={{ color: '#4A5174', fontFamily: 'OpenSans-bold' }}
              >
                {t("Cash Price")}:
              </Typography>
              <Typography
                style={{
                  fontFamily: 'OpenSans-bold',
                  fontSize: '14px',
                  float: 'right',
                  paddingLeft: '70px',
                }}
              >
                ${PackagerightValue.cashPrice}
              </Typography>
            </Grid>
            <Grid
              md={12}
              style={{ display: 'flex', flexWrap: 'wrap' }}
              className={classes.margincard}
            >
              <Typography
                style={{ color: '#4A5174', fontFamily: 'OpenSans-bold' }}
              >
                {t("Total Cost")}:
              </Typography>
              <Typography
                style={{
                  fontFamily: 'OpenSans-bold',
                  fontSize: '14px',
                  float: 'right',
                  paddingLeft: '70px',
                }}
              >
                ${PackagerightValue.totalCost}
              </Typography>
            </Grid>
            <Grid className={`${classes.py4} ${classes.textCenter}`}>
              <RACButton
                className={classes.mxe}
                variant="contained"
                color="primary"
                onClick={() => triggerPackageNextModal('PRTD')}
              >
                {t("ADD")}
              </RACButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  };
  function extractPartFromUrl(url: any, prefixToRemove: any): any {
    const currentUrl: URL = new URL(url);
    const pathname: string = currentUrl.pathname;
    return pathname.replace(prefixToRemove, '');
  }
  const verificationWarningPopupFn = () => {
    return (
      <Grid item md={12} className="px-2">
        <Grid item md={12} className="text-center">
          <WarningIcon></WarningIcon>
          <Typography style={{ marginTop: '18px', marginBottom: '10px', fontSize: '18px' }}>
            {t("This customer has incomplete verification, Do you want to continue?")}
          </Typography>
        </Grid>
        <Grid container style={{ justifyContent: 'center' }}>
          <RACButton
            color='primary'
            variant='contained'
            style={{ marginRight: '10px' }}
            onClick={() => {
              setverificationWarningPopup(false);
              history.push({
                pathname: `/customer/update/${customerId}/customer`,
                state: { navFrom: extractPartFromUrl(window.location.href, '/menu/') }
              })
            }}

          >
            {t("Verify Customer")}
          </RACButton>
          <RACButton
            color='primary'
            variant='outlined'
            onClick={() => {
              setverificationWarningPopup(false);
              setVerifcationRequiredContinue(true)
            }}
          >
            {t("Continue")}
          </RACButton>
        </Grid>
      </Grid>
    );
  };


  const SomethingWentWrongPopup = () => {
    return (
      <div
        id="initialpayment"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-hidden="true"
      >
        <Grid className={classes.textCenter} style={{ padding: '30px 30px' }}>
          <Alerticon></Alerticon>

          <Typography className={classes.formLabel}>
            {t("Something went wrong!")}
          </Typography>
        </Grid>
        <Grid
          item
          md={12}
          className={`${classes.mt3} ${classes.pb4} ${classes.textCenter}`}
        >
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={() => {
              setSomethingWentWrongPopup(false);
              window.location.href = `/agreement/rental/itemsearch/${customerId}`
            }
            }
          >
            {t("Ok")}
          </RACButton>
        </Grid>
      </div>
    );
  };

  const PackageNotAvailablePopup = () => {
    return (
      <div
        id="packageNotAvailable"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-hidden="true"
      >
        <Grid className={classes.textCenter} style={{ padding: '15px 15px' }}>
          <Alerticon></Alerticon>
          <Typography className={classes.formLabel}>
            {t("Package Not Available in Store Inventory. Please Search for a different Package.")}
          </Typography>
        </Grid>
        <Grid
          item
          md={12}
          className={`${classes.mt3} ${classes.pb4} ${classes.textCenter}`}
        >
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={() => {
              setPackageNotAvailableOpen(false)
              window.location.href = `/agreement/rental/itemsearch/${customerId}`;
            }
            }
          >
            {t("Ok")}
          </RACButton>
        </Grid>
      </div>
    );
  };

  return (
    <div className={`${classes.agreementContainerSpacing} ${showItemSearch}`}>
      <div>
        <RACModalCard
          isOpen={somethingWentWrongPopup}
          closeIcon={false}
          maxWidth="xs"
          borderRadius={'20px !important'}
        >
          {SomethingWentWrongPopup()}
        </RACModalCard>
        {loaderBundle.masterLoader ? (
          <Grid className={classes.masterLoader}>
            <Grid className={classes.Loader}>
              <CircularProgress />
            </Grid>
          </Grid>
        ) : null}
        <Grid container spacing={2} className={dynamicViewClass}>
          <Grid item className={altersearch}>
            <SearchFilter
              searchClick={searchClick}
              // PackagedropdownOnClick={PackagedropdownOnClick}
              IsPackage={true}
              clearbtnClick={clearbtnClick}
              triggerItemPriceByData={pricingCallTrigger}
              throwStyle={classes}
              throwSalesLead={salesLeadData}
              throwPackage={receivedpackage}
              throwSelectedPackage={storeSelectedPackage}
              throwItemArray={itemArray}
              throwpackageList={packageList}
            />
            <div>
              {loaderBundle.loaderController === true &&
                loaderBundle.Gridloader === true ? (
                <ExceptionController
                  throwExceptionDecider="Data Delay"
                  throwStyle={classes}
                />
              ) : (
                gridCallMethod()
              )}
            </div>

            <ModalContainer
              throwModalController={modalController}
              throwMethodAssigner={methodAssigner}
              throwPricingException={pricingException}
              throwFormException={formException}
              throwPriceExceptionMessage={PricexeptionMessage}
            />
          </Grid>
          {showAddedItem ? (
            <Usercontext.Provider value={internalContextData}>
              <AddedItem
                triggeroneDelete={deleteSingleItem}
                setreceiveAgreementRate={receiveAgreementRate}
                setreceiveAgreementTerm={receiveAgreementTerm}
                throwAwaitPendingLegalPrice={awaitPendingLegalPrice}
                throwHasPendingLegalPrice={hasPendingLegalPrice}
                customerVerifyLevel={verifyLevel != undefined ? verifyLevel : getCustomerResponse?.GetApproval?.value?.customerApprovalDetails?.verifyLevel}
                customerApprovalDetails={customerApprovalDetails != undefined ? customerApprovalDetails : getCustomerResponse?.GetApproval?.value?.customerApprovalDetails}
                customerDetails={getCustomerResponse?.GetCustomer}
                productExclusions={getCustomerResponse?.GetApproval?.value?.customerApprovalDetails?.productExclusions} //Test this
                module="Agreement"
                throwPackage={receivedpackage}
                priceexceptionMessage={pricingException}
                setCompetitorValue={receiveCompetitor}
                triggerSetToDefault={calculateSetToDefault}
                throwStyle={classes}
                // childFunc={childFunc}
                setCompetitorDropValue={receiveCompetitorDDValue}
                throwcollectCompetitor={collectCompetitor}
              />
            </Usercontext.Provider>
          ) : null}
        </Grid>
        {getCustomerResponse && getCustomerResponse?.GetApproval?.value?.customerApprovalDetails?.verificationStatus == 'COMPLETED' || getCustomerResponse?.GetApproval?.value?.customerApprovalDetails?.verificationStatus == 'NOTREQUIRED' || verifcationRequiredContinue ?
          <FooterContent
            setItemsearchCompleted={props.setItemSearchCompleted}
            controlData={footerControlData}
            throwStyle={classes}
            throwCopy={bucketCopy}
            throwpackageCriteria={packageCriteria}
            triggerMinMaxPopup={minMaxException}
            func={pull_data}
            throwPackageState={isPackage}
            throwItemArray={itemArray}
            givereceivedpackage={receivedpackage}
            sometrigger={suppiler}
            selectedPackage={selectedPackage}
            packageListData={packageList}
          />
          : featureFlagDetails.CustomerVerificationOptimization == 0 || featureFlagDetails?.MXDecisionEngine == 1 ? <FooterContent
            setItemsearchCompleted={props.setItemSearchCompleted}
            controlData={footerControlData}
            throwStyle={classes}
            throwCopy={bucketCopy}
            throwpackageCriteria={packageCriteria}
            triggerMinMaxPopup={minMaxException}
            func={pull_data}
            throwPackageState={isPackage}
            throwItemArray={itemArray}
            givereceivedpackage={receivedpackage}
            sometrigger={suppiler}
            selectedPackage={selectedPackage}
            packageListData={packageList}
          /> : null}

        {SecondFactorEnabled === true ? (
          <SecondFactor
            // setTwoFactorCancelClick={setTwoFactorCancelClick}
            setTwoFactorCancelClick={SLACancel}
            // setTwoFactorCompleted={setTwoFactorCompleted}
            setTwoFactorCompleted={SLACompleted}
            closeSLAClicked={closeSLA}
            // setRoleFromSLAModule={provideSLAData}
            moduleName={ModuleName}
            currentRole={CurrentRole}
            // minRole={SLAMinRole}
            throwCurrentPage="ItemSearch"
          />
        ) : null}
        <RACModalCard
          isOpen={PackageNotAvailableOpen}
          closeIcon={false}
          maxWidth="xs"
          borderRadius={'20px !important'}
        >
          {PackageNotAvailablePopup()}
        </RACModalCard>
        <RACModalCard
          isOpen={openPriceTag}
          maxWidth={'sm'}
          borderRadius={'25px !important'}
          title={t('Please choose the price')}
          closeIcon={true}
          onClose={() => setOpenPriceTag(false)}
          //eslint-disable-next-line react/no-children-prop
          children={openPriceModal()}
        ></RACModalCard>

        <RACModalCard
          isOpen={openPackagePriceTag}
          maxWidth={'sm'}
          borderRadius={'25px !important'}
          title={t("Please choose the price")}
          closeIcon={true}
          onClose={() => setopenPackagePriceTag(false)}
          //eslint-disable-next-line react/no-children-prop
          children={openPackagePriceModal()}
        ></RACModalCard>
        <RACModalCard
          isOpen={verificationWarningPopup}
          maxWidth={'sm'}
          borderRadius={'25px !important'}
          closeIcon={true}
          onClose={() => {
            setverificationWarningPopup(false);
            setVerifcationRequiredContinue(true)
          }}

          //eslint-disable-next-line react/no-children-prop
          children={verificationWarningPopupFn()}
        ></RACModalCard>


      </div>
    </div >
  );
};

export default SearchResult;
